// Translations for all supported languages
export const translations = {
  it: {
    // Navigation
    nav: {
      home: "Home",
      products: "Prodotti",
      about: "Chi Siamo",
      contact: "Contatti",
      terms: "Termini e Condizioni",
      management: "Gestione",
      cart: "Carrello",
      login: "Accedi",
      logout: "Esci",
      account: "Il mio account"
    },
    
    // Homepage
    home: {
      hero_title: "Benvenuti all'Edicola Cerasuolo",
      hero_subtitle: "Modellismo F1, Pokémon TCG e Collezionismo di Qualità",
      hero_description: "Scopri la nostra selezione di modellismo F1, Pokémon TCG e collezioni speciali",
      shop_now: "Scopri i Prodotti",
      contact_us: "Contattaci",
      
      // Features
      secure_shipping: "SPEDIZIONI ASSICURATE",
      secure_shipping_desc: "Garantite fino a €99 - Oltre €99 a carico del cliente",
      pay_3_installments: "PAGA IN 3 RATE",
      pay_3_installments_desc: "Senza interessi, senza costi aggiuntivi!",
      paypal_3_rates: "PayPal - Paga in 3 Rate",
      
      // Pre-sale section
      presale_title: "Prodotti in Prevendita",
      presale_desc: "Prenota ora i prossimi arrivi con vantaggi esclusivi",
      presale_price: "Prezzo scontato",
      presale_delivery: "Consegna garantita",
      presale_btn: "Scopri le Prevendite",
      
      reservation_title: "Prodotti in Prenotazione",
      reservation_desc: "Assicurati i tuoi collezionabili preferiti",
      reservation_free: "Riservazione gratuita",
      reservation_notify: "Notifica disponibilità",
      reservation_btn: "Vedi le Prenotazioni",
      
      // Online sale
      online_sale: "Vendita Online",
      online_sale_desc: "Sfoglia il nostro catalogo e scegli i prodotti che ti interessano",
      go_to_products: "Vai ai Prodotti",
      
      // Payment methods
      payment_methods: "Modalità di Pagamento",
      payment_methods_desc: "Scegli il metodo più comodo per te",
      bank_transfer: "Bonifico Bancario",
      credit_card: "Carta di Credito",
      paypal: "PayPal",
      klarna_3: "Klarna in 3 Rate",
      
      // About preview
      about_title: "Chi Siamo",
      about_desc: "La nostra edicola è gestita con passione da Cerasuolo Massimiliano e Rita Colarusso, storica famiglia di edicolanti a Napoli con anni di esperienza nel settore.",
      about_more: "Scopri di più su di noi",
      
      // Specialties
      f1_modeling: "Modellismo F1",
      f1_modeling_desc: "Le grandi Ferrari, McLaren, Mercedes e tutte le scuderie storiche. Modelli in scala delle migliori case editrici.",
      pokemon_tcg: "Pokémon TCG",
      pokemon_tcg_desc: "Mystery Box, carte rare, collezioni speciali e tutti i prodotti ufficiali del Trading Card Game.",
      online_selling: "Vendita Online",
      online_selling_desc: "Trova i nostri prodotti anche su eBay e Wallapop per acquisti comodi da casa.",
      
      discover_products: "Scopri i Prodotti",
      
      // New homepage keys
      exclusive_collections: "Collezioni Esclusive dal 1985",
      hero_main_title: "Modellismo, Pokemon e Pezzi da Collezione",
      hero_main_desc: "Spedizioni in tutto il mondo — Pagamenti sicuri — Pezzi rari e introvabili",
      buy_now: "ACQUISTA ORA",
      discover_bestsellers: "Scopri i Bestseller",
      offers_this_week: "Offerte valide solo questa settimana",
      explore_collections: "Esplora le Collezioni",
      bestsellers_title: "I Piu Venduti del Momento",
      bestsellers_desc: "Scelti dai nostri clienti — Disponibilita limitata",
      view_all_catalog: "VEDI TUTTO IL CATALOGO",
      limited_offer: "Offerta Limitata",
      weekly_promo: "Promo Settimanale",
      weekly_promo_desc: "Spedizione a tariffa ridotta + sconto sul 3° prodotto — Solo questa settimana!",
      discover_offer: "SCOPRI L'OFFERTA",
      insured_shipping: "Spedizioni Assicurate",
      insured_shipping_desc: "Garanzia fino a €99 — Tracciamento sempre incluso",
      pay_installments: "Paga in 3 Rate",
      pay_installments_desc: "Con Klarna — Senza interessi, senza pensieri",
      secure_payments: "Pagamenti 100% Sicuri",
      secure_payments_desc: "Carta, Bonifico, Klarna, Satispay",
      customer_reviews: "Cosa Dicono i Nostri Clienti",
      verified_reviews: "Recensioni verificate dai nostri acquirenti",
      leave_review: "Lascia una Recensione",
      close_form: "Chiudi",
      no_reviews: "Nessuna recensione ancora — Sii il primo!",
      stay_updated: "Resta Aggiornato",
      newsletter_desc: "Nuovi arrivi, offerte esclusive e anteprime direttamente nella tua email",
      subscribe_now: "ISCRIVITI ORA",
      sending: "Invio...",
      follow_social: "Seguici sui social",
      bestseller_badge: "BESTSELLER",
      preorder_badge: "PREORDINE",
      available: "Disponibile",
      preorder_now: "Prenota subito",
      last_pieces: "Ultimi",
      pieces: "pezzi!",
      available_from: "Disponibile dal",
      your_email: "La tua email",
      your_name_opt: "Il tuo nome (opzionale)",
      submit_review: "Invia Recensione",
      name: "Nome",
      email: "Email",
      product: "Prodotto",
      select_product: "Seleziona prodotto...",
      rating: "Valutazione",
      comment: "Commento"
    },
    
    // Products page
    products: {
      title: "I Nostri Prodotti",
      subtitle: "Scopri le nostre collezioni",
      catalog_updating: "Catalogo in Aggiornamento",
      catalog_updating_desc: "Stiamo caricando il nostro catalogo completo. Nel frattempo, contattaci per informazioni sui prodotti disponibili!",
      filter_category: "Filtra per Categoria",
      all_categories: "Tutte le Categorie",
      search_placeholder: "Cerca prodotti...",
      sort_by: "Ordina per:",
      sort_newest: "Più Recenti",
      sort_price_low: "Prezzo: Basso a Alto",
      sort_price_high: "Prezzo: Alto a Basso",
      add_to_cart: "Aggiungi al Carrello",
      request_info: "Richiedi Info",
      out_of_stock: "Esaurito",
      in_stock: "Disponibile",
      call_us: "Chiamaci"
    },
    
    // Product detail
    product: {
      description: "Descrizione",
      details: "Dettagli Prodotto",
      category: "Categoria",
      price: "Prezzo",
      quantity: "Quantità",
      add_to_cart: "Aggiungi al Carrello",
      out_of_stock: "Prodotto Esaurito",
      back_to_products: "Torna ai Prodotti"
    },
    
    // Cart
    cart: {
      title: "Carrello",
      empty: "Il tuo carrello è vuoto",
      empty_desc: "Aggiungi prodotti per iniziare lo shopping",
      continue_shopping: "Continua lo Shopping",
      product: "Prodotto",
      quantity: "Quantità",
      price: "Prezzo",
      total: "Totale",
      subtotal: "Subtotale",
      shipping: "Spedizione",
      order_total: "Totale Ordine",
      proceed_checkout: "Procedi al Checkout",
      remove: "Rimuovi"
    },
    
    // Checkout
    checkout: {
      title: "Checkout",
      customer_info: "Informazioni Cliente",
      name: "Nome Completo",
      email: "Email",
      phone: "Telefono",
      address: "Indirizzo",
      city: "Città",
      zip: "CAP",
      country: "Paese",
      notes: "Note (opzionale)",
      payment_method: "Metodo di Pagamento",
      cash_on_delivery: "Contrassegno",
      bank_transfer: "Bonifico Bancario",
      paypal: "PayPal",
      credit_card: "Carta di Credito/Stripe",
      place_order: "Conferma Ordine",
      order_summary: "Riepilogo Ordine"
    },
    
    // About page
    about: {
      title: "Chi Siamo",
      subtitle: "La nostra storia e la nostra passione",
      intro: "La nostra edicola è gestita con passione da Cerasuolo Massimiliano e Rita Colarusso, storica famiglia di edicolanti a Napoli con anni di esperienza nel settore.",
      specialization: "Ci siamo specializzati nel modellismo F1 delle migliori case editrici e nelle collezioni Pokémon, offrendo ai nostri clienti prodotti di qualità e un servizio personalizzato."
    },
    
    // Contact page
    contact: {
      title: "Contattaci",
      subtitle: "Siamo qui per aiutarti",
      info: "Informazioni di Contatto",
      address: "Indirizzo",
      address_value: "Corso Europa 175, 80010 Villaricca (NA)",
      phone: "Telefono",
      email: "Email",
      hours: "Orari di Apertura",
      monday_friday: "Lunedì - Venerdì",
      saturday: "Sabato",
      sunday: "Domenica",
      closed: "Chiuso",
      send_message: "Invia Messaggio",
      your_name: "Il tuo nome",
      your_email: "La tua email",
      your_message: "Il tuo messaggio",
      send: "Invia"
    },
    
    // Footer
    footer: {
      copyright: "© 2024 Edicola Cerasuolo - Corso Europa 175, 80010 Villaricca (NA)",
      info: "Per informazioni sui prodotti"
    },
    
    // Common
    common: {
      loading: "Caricamento...",
      error: "Errore",
      success: "Successo",
      close: "Chiudi",
      save: "Salva",
      cancel: "Annulla",
      delete: "Elimina",
      edit: "Modifica",
      view: "Visualizza",
      search: "Cerca",
      filter: "Filtra",
      sort: "Ordina"
    }
  },
  
  en: {
    nav: {
      home: "Home",
      products: "Products",
      about: "About Us",
      contact: "Contact",
      terms: "Terms & Conditions",
      management: "Management",
      cart: "Cart",
      login: "Login",
      logout: "Logout"
    },
    
    home: {
      hero_title: "Welcome to Edicola Cerasuolo",
      hero_subtitle: "F1 Modeling, Pokémon TCG and Quality Collectibles",
      hero_description: "Discover our selection of F1 models, Pokémon TCG and special collections",
      shop_now: "Shop Now",
      contact_us: "Contact Us",
      
      secure_shipping: "INSURED SHIPPING",
      secure_shipping_desc: "Guaranteed up to €99 - Over €99 at customer's expense",
      pay_3_installments: "PAY IN 3 INSTALLMENTS",
      pay_3_installments_desc: "Interest-free, no additional costs!",
      paypal_3_rates: "PayPal - Pay in 3 Installments",
      
      presale_title: "Pre-sale Products",
      presale_desc: "Pre-order upcoming arrivals with exclusive benefits",
      presale_price: "Discounted price",
      presale_delivery: "Guaranteed delivery",
      presale_btn: "Discover Pre-sales",
      
      reservation_title: "Reservation Products",
      reservation_desc: "Secure your favorite collectibles",
      reservation_free: "Free reservation",
      reservation_notify: "Availability notification",
      reservation_btn: "View Reservations",
      
      online_sale: "Online Store",
      online_sale_desc: "Browse our catalog and choose the products you're interested in",
      go_to_products: "Go to Products",
      
      payment_methods: "Payment Methods",
      payment_methods_desc: "Choose the most convenient method for you",
      bank_transfer: "Bank Transfer",
      credit_card: "Credit Card",
      paypal: "PayPal",
      klarna_3: "Klarna 3 Installments",
      
      about_title: "About Us",
      about_desc: "Our newsstand is passionately managed by Cerasuolo Massimiliano and Rita Colarusso, a historic family of newsagents in Naples with years of experience in the sector.",
      about_more: "Learn more about us",
      
      f1_modeling: "F1 Modeling",
      f1_modeling_desc: "The great Ferraris, McLarens, Mercedes and all historic teams. Scale models from the best publishers.",
      pokemon_tcg: "Pokémon TCG",
      pokemon_tcg_desc: "Mystery Boxes, rare cards, special collections and all official Trading Card Game products.",
      online_selling: "Online Selling",
      online_selling_desc: "Find our products on eBay and Wallapop for convenient home shopping.",
      
      discover_products: "Discover Products",
      exclusive_collections: "Exclusive Collections since 1985",
      hero_main_title: "Modeling, Pokemon and Collectibles",
      hero_main_desc: "Worldwide shipping — Secure payments — Rare and hard-to-find pieces",
      buy_now: "BUY NOW",
      discover_bestsellers: "Discover Bestsellers",
      offers_this_week: "Offers valid this week only",
      explore_collections: "Explore Collections",
      bestsellers_title: "Best Sellers",
      bestsellers_desc: "Chosen by our customers — Limited availability",
      view_all_catalog: "VIEW FULL CATALOG",
      limited_offer: "Limited Offer",
      weekly_promo: "Weekly Promo",
      weekly_promo_desc: "Reduced shipping + discount on 3rd product — This week only!",
      discover_offer: "DISCOVER THE OFFER",
      insured_shipping: "Insured Shipping",
      insured_shipping_desc: "Guaranteed up to €99 — Tracking always included",
      pay_installments: "Pay in 3 Installments",
      pay_installments_desc: "With Klarna — Interest-free, worry-free",
      secure_payments: "100% Secure Payments",
      secure_payments_desc: "Card, Bank Transfer, Klarna, Satispay",
      customer_reviews: "What Our Customers Say",
      verified_reviews: "Verified reviews from our buyers",
      leave_review: "Leave a Review",
      close_form: "Close",
      no_reviews: "No reviews yet — Be the first!",
      stay_updated: "Stay Updated",
      newsletter_desc: "New arrivals, exclusive offers and previews directly in your email",
      subscribe_now: "SUBSCRIBE NOW",
      sending: "Sending...",
      follow_social: "Follow us on social media",
      bestseller_badge: "BESTSELLER",
      preorder_badge: "PREORDER",
      available: "Available",
      preorder_now: "Pre-order now",
      last_pieces: "Last",
      pieces: "pieces!",
      available_from: "Available from",
      your_email: "Your email",
      your_name_opt: "Your name (optional)",
      submit_review: "Submit Review",
      name: "Name",
      email: "Email",
      product: "Product",
      select_product: "Select product...",
      rating: "Rating",
      comment: "Comment"
    },
    
    products: {
      title: "Our Products",
      subtitle: "Discover our collections",
      catalog_updating: "Catalog Updating",
      catalog_updating_desc: "We're uploading our complete catalog. Meanwhile, contact us for information on available products!",
      filter_category: "Filter by Category",
      all_categories: "All Categories",
      search_placeholder: "Search products...",
      sort_by: "Sort by:",
      sort_newest: "Newest",
      sort_price_low: "Price: Low to High",
      sort_price_high: "Price: High to Low",
      add_to_cart: "Add to Cart",
      request_info: "Request Info",
      out_of_stock: "Out of Stock",
      in_stock: "In Stock",
      call_us: "Call Us"
    },
    
    product: {
      description: "Description",
      details: "Product Details",
      category: "Category",
      price: "Price",
      quantity: "Quantity",
      add_to_cart: "Add to Cart",
      out_of_stock: "Product Out of Stock",
      back_to_products: "Back to Products"
    },
    
    cart: {
      title: "Shopping Cart",
      empty: "Your cart is empty",
      empty_desc: "Add products to start shopping",
      continue_shopping: "Continue Shopping",
      product: "Product",
      quantity: "Quantity",
      price: "Price",
      total: "Total",
      subtotal: "Subtotal",
      shipping: "Shipping",
      order_total: "Order Total",
      proceed_checkout: "Proceed to Checkout",
      remove: "Remove"
    },
    
    checkout: {
      title: "Checkout",
      customer_info: "Customer Information",
      name: "Full Name",
      email: "Email",
      phone: "Phone",
      address: "Address",
      city: "City",
      zip: "ZIP Code",
      country: "Country",
      notes: "Notes (optional)",
      payment_method: "Payment Method",
      cash_on_delivery: "Cash on Delivery",
      bank_transfer: "Bank Transfer",
      paypal: "PayPal",
      credit_card: "Credit Card/Stripe",
      place_order: "Place Order",
      order_summary: "Order Summary"
    },
    
    about: {
      title: "About Us",
      subtitle: "Our story and passion",
      intro: "Our newsstand is passionately managed by Cerasuolo Massimiliano and Rita Colarusso, a historic family of newsagents in Naples with years of experience in the sector.",
      specialization: "We specialize in F1 modeling from the best publishers and Pokémon collections, offering our customers quality products and personalized service."
    },
    
    contact: {
      title: "Contact Us",
      subtitle: "We're here to help",
      info: "Contact Information",
      address: "Address",
      address_value: "Corso Europa 175, 80010 Villaricca (NA)",
      phone: "Phone",
      email: "Email",
      hours: "Opening Hours",
      monday_friday: "Monday - Friday",
      saturday: "Saturday",
      sunday: "Sunday",
      closed: "Closed",
      send_message: "Send Message",
      your_name: "Your name",
      your_email: "Your email",
      your_message: "Your message",
      send: "Send"
    },
    
    footer: {
      copyright: "© 2024 Edicola Cerasuolo - Corso Europa 175, 80010 Villaricca (NA)",
      info: "For product information"
    },
    
    common: {
      loading: "Loading...",
      error: "Error",
      success: "Success",
      close: "Close",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      view: "View",
      search: "Search",
      filter: "Filter",
      sort: "Sort"
    }
  },
  
  fr: {
    nav: {
      home: "Accueil",
      products: "Produits",
      about: "Qui Sommes-Nous",
      contact: "Contact",
      terms: "Conditions Générales",
      management: "Gestion",
      cart: "Panier",
      login: "Connexion",
      logout: "Déconnexion"
    },
    
    home: {
      hero_title: "Bienvenue chez Edicola Cerasuolo",
      hero_subtitle: "Modélisme F1, Pokémon TCG et Objets de Collection de Qualité",
      hero_description: "Découvrez notre sélection de modèles F1, Pokémon TCG et collections spéciales",
      shop_now: "Découvrir les Produits",
      contact_us: "Nous Contacter",
      
      secure_shipping: "LIVRAISON ASSURÉE",
      secure_shipping_desc: "Garantie jusqu'à 99€ - Au-delà de 99€ à la charge du client",
      pay_3_installments: "PAYER EN 3 FOIS",
      pay_3_installments_desc: "Sans intérêts, sans frais supplémentaires!",
      paypal_3_rates: "PayPal - Payer en 3 Fois",
      
      presale_title: "Produits en Prévente",
      presale_desc: "Précommandez les prochaines arrivées avec des avantages exclusifs",
      presale_price: "Prix réduit",
      presale_delivery: "Livraison garantie",
      presale_btn: "Découvrir les Préventes",
      
      reservation_title: "Produits en Réservation",
      reservation_desc: "Assurez-vous vos objets de collection préférés",
      reservation_free: "Réservation gratuite",
      reservation_notify: "Notification de disponibilité",
      reservation_btn: "Voir les Réservations",
      
      online_sale: "Vente en Ligne",
      online_sale_desc: "Parcourez notre catalogue et choisissez les produits qui vous intéressent",
      go_to_products: "Voir les Produits",
      
      payment_methods: "Méthodes de Paiement",
      payment_methods_desc: "Choisissez la méthode la plus pratique pour vous",
      bank_transfer: "Virement Bancaire",
      credit_card: "Carte de Crédit",
      paypal: "PayPal",
      klarna_3: "Klarna en 3 Fois",
      
      about_title: "Qui Sommes-Nous",
      about_desc: "Notre kiosque est géré avec passion par Cerasuolo Massimiliano et Rita Colarusso, famille historique de marchands de journaux à Naples avec des années d'expérience dans le secteur.",
      about_more: "En savoir plus sur nous",
      
      f1_modeling: "Modélisme F1",
      f1_modeling_desc: "Les grandes Ferrari, McLaren, Mercedes et toutes les écuries historiques. Modèles à l'échelle des meilleurs éditeurs.",
      pokemon_tcg: "Pokémon JCC",
      pokemon_tcg_desc: "Mystery Box, cartes rares, collections spéciales et tous les produits officiels du Jeu de Cartes à Collectionner.",
      online_selling: "Vente en Ligne",
      online_selling_desc: "Trouvez nos produits sur eBay et Wallapop pour des achats pratiques depuis chez vous.",
      
      discover_products: "Découvrir les Produits",
      exclusive_collections: "Collections Exclusives depuis 1985",
      hero_main_title: "Modélisme, Pokemon et Pièces de Collection",
      hero_main_desc: "Expéditions dans le monde entier — Paiements sécurisés — Pièces rares",
      buy_now: "ACHETEZ MAINTENANT",
      discover_bestsellers: "Découvrir les Bestsellers",
      offers_this_week: "Offres valables cette semaine uniquement",
      explore_collections: "Explorer les Collections",
      bestsellers_title: "Les Plus Vendus",
      bestsellers_desc: "Choisis par nos clients — Disponibilité limitée",
      view_all_catalog: "VOIR TOUT LE CATALOGUE",
      limited_offer: "Offre Limitée", weekly_promo: "Promo Hebdomadaire",
      weekly_promo_desc: "Livraison réduite + remise sur le 3ème produit — Cette semaine seulement!",
      discover_offer: "DÉCOUVRIR L'OFFRE",
      insured_shipping: "Livraison Assurée", insured_shipping_desc: "Garantie jusqu'à €99 — Suivi toujours inclus",
      pay_installments: "Payer en 3 Fois", pay_installments_desc: "Avec Klarna — Sans intérêts",
      secure_payments: "Paiements 100% Sécurisés", secure_payments_desc: "Carte, Virement, Klarna, Satispay",
      customer_reviews: "Ce que Disent Nos Clients", verified_reviews: "Avis vérifiés de nos acheteurs",
      leave_review: "Laisser un Avis", close_form: "Fermer", no_reviews: "Pas encore d'avis — Soyez le premier!",
      stay_updated: "Restez Informé", newsletter_desc: "Nouveautés, offres exclusives et avant-premières directement dans votre email",
      subscribe_now: "S'INSCRIRE MAINTENANT", sending: "Envoi...", follow_social: "Suivez-nous",
      bestseller_badge: "BESTSELLER", preorder_badge: "PRÉCOMMANDE", available: "Disponible", preorder_now: "Précommandez",
      last_pieces: "Derniers", pieces: "pièces!", available_from: "Disponible dès le",
      your_email: "Votre email", your_name_opt: "Votre nom (optionnel)", submit_review: "Envoyer l'Avis",
      name: "Nom", email: "Email", product: "Produit", select_product: "Sélectionner un produit...", rating: "Note", comment: "Commentaire"
    },
    
    products: {
      title: "Nos Produits",
      subtitle: "Découvrez nos collections",
      catalog_updating: "Catalogue en Mise à Jour",
      catalog_updating_desc: "Nous mettons à jour notre catalogue complet. En attendant, contactez-nous pour des informations sur les produits disponibles!",
      filter_category: "Filtrer par Catégorie",
      all_categories: "Toutes les Catégories",
      search_placeholder: "Rechercher des produits...",
      sort_by: "Trier par:",
      sort_newest: "Plus Récents",
      sort_price_low: "Prix: Bas à Élevé",
      sort_price_high: "Prix: Élevé à Bas",
      add_to_cart: "Ajouter au Panier",
      request_info: "Demander Info",
      out_of_stock: "Épuisé",
      in_stock: "Disponible",
      call_us: "Appelez-nous"
    },
    
    product: {
      description: "Description",
      details: "Détails du Produit",
      category: "Catégorie",
      price: "Prix",
      quantity: "Quantité",
      add_to_cart: "Ajouter au Panier",
      out_of_stock: "Produit Épuisé",
      back_to_products: "Retour aux Produits"
    },
    
    cart: {
      title: "Panier",
      empty: "Votre panier est vide",
      empty_desc: "Ajoutez des produits pour commencer vos achats",
      continue_shopping: "Continuer les Achats",
      product: "Produit",
      quantity: "Quantité",
      price: "Prix",
      total: "Total",
      subtotal: "Sous-total",
      shipping: "Livraison",
      order_total: "Total Commande",
      proceed_checkout: "Passer à la Caisse",
      remove: "Retirer"
    },
    
    checkout: {
      title: "Paiement",
      customer_info: "Informations Client",
      name: "Nom Complet",
      email: "Email",
      phone: "Téléphone",
      address: "Adresse",
      city: "Ville",
      zip: "Code Postal",
      country: "Pays",
      notes: "Notes (optionnel)",
      payment_method: "Méthode de Paiement",
      cash_on_delivery: "Paiement à la Livraison",
      bank_transfer: "Virement Bancaire",
      paypal: "PayPal",
      credit_card: "Carte de Crédit/Stripe",
      place_order: "Confirmer la Commande",
      order_summary: "Récapitulatif de Commande"
    },
    
    about: {
      title: "Qui Sommes-Nous",
      subtitle: "Notre histoire et notre passion",
      intro: "Notre kiosque est géré avec passion par Cerasuolo Massimiliano et Rita Colarusso, famille historique de marchands de journaux à Naples avec des années d'expérience dans le secteur.",
      specialization: "Nous sommes spécialisés dans le modélisme F1 des meilleurs éditeurs et les collections Pokémon, offrant à nos clients des produits de qualité et un service personnalisé."
    },
    
    contact: {
      title: "Contactez-Nous",
      subtitle: "Nous sommes là pour vous aider",
      info: "Informations de Contact",
      address: "Adresse",
      address_value: "Corso Europa 175, 80010 Villaricca (NA)",
      phone: "Téléphone",
      email: "Email",
      hours: "Heures d'Ouverture",
      monday_friday: "Lundi - Vendredi",
      saturday: "Samedi",
      sunday: "Dimanche",
      closed: "Fermé",
      send_message: "Envoyer un Message",
      your_name: "Votre nom",
      your_email: "Votre email",
      your_message: "Votre message",
      send: "Envoyer"
    },
    
    footer: {
      copyright: "© 2024 Edicola Cerasuolo - Corso Europa 175, 80010 Villaricca (NA)",
      info: "Pour informations sur les produits"
    },
    
    common: {
      loading: "Chargement...",
      error: "Erreur",
      success: "Succès",
      close: "Fermer",
      save: "Enregistrer",
      cancel: "Annuler",
      delete: "Supprimer",
      edit: "Modifier",
      view: "Voir",
      search: "Rechercher",
      filter: "Filtrer",
      sort: "Trier"
    }
  },
  
  de: {
    nav: {
      home: "Startseite",
      products: "Produkte",
      about: "Über Uns",
      contact: "Kontakt",
      terms: "Allgemeine Geschäftsbedingungen",
      management: "Verwaltung",
      cart: "Warenkorb",
      login: "Anmelden",
      logout: "Abmelden"
    },
    
    home: {
      hero_title: "Willkommen bei Edicola Cerasuolo",
      hero_subtitle: "F1-Modellbau, Pokémon TCG und Hochwertige Sammlerstücke",
      hero_description: "Entdecken Sie unsere Auswahl an F1-Modellen, Pokémon TCG und Sondersammlungen",
      shop_now: "Produkte Entdecken",
      contact_us: "Kontaktieren Sie Uns",
      
      secure_shipping: "VERSICHERTE LIEFERUNG",
      secure_shipping_desc: "Garantiert bis 99€ - Über 99€ auf Kosten des Kunden",
      pay_3_installments: "IN 3 RATEN ZAHLEN",
      pay_3_installments_desc: "Zinsfrei, keine zusätzlichen Kosten!",
      paypal_3_rates: "PayPal - In 3 Raten Zahlen",
      
      presale_title: "Vorverkauf Produkte",
      presale_desc: "Vorbestellen Sie kommende Neuheiten mit exklusiven Vorteilen",
      presale_price: "Ermäßigter Preis",
      presale_delivery: "Garantierte Lieferung",
      presale_btn: "Vorverkäufe Entdecken",
      
      reservation_title: "Reservierungs Produkte",
      reservation_desc: "Sichern Sie sich Ihre Lieblings-Sammlerstücke",
      reservation_free: "Kostenlose Reservierung",
      reservation_notify: "Verfügbarkeitsbenachrichtigung",
      reservation_btn: "Reservierungen Ansehen",
      
      online_sale: "Online-Shop",
      online_sale_desc: "Durchsuchen Sie unseren Katalog und wählen Sie die Produkte, die Sie interessieren",
      go_to_products: "Zu den Produkten",
      
      payment_methods: "Zahlungsmethoden",
      payment_methods_desc: "Wählen Sie die für Sie bequemste Methode",
      bank_transfer: "Banküberweisung",
      credit_card: "Kreditkarte",
      paypal: "PayPal",
      klarna_3: "Klarna 3 Raten",
      
      about_title: "Über Uns",
      about_desc: "Unser Kiosk wird mit Leidenschaft von Cerasuolo Massimiliano und Rita Colarusso geführt, einer historischen Familie von Zeitungshändlern in Neapel mit jahrelanger Erfahrung in diesem Bereich.",
      about_more: "Mehr über uns erfahren",
      
      f1_modeling: "F1-Modellbau",
      f1_modeling_desc: "Die großen Ferraris, McLarens, Mercedes und alle historischen Teams. Maßstabsgetreue Modelle der besten Verlage.",
      pokemon_tcg: "Pokémon TCG",
      pokemon_tcg_desc: "Mystery Boxen, seltene Karten, Sondersammlungen und alle offiziellen Trading Card Game Produkte.",
      online_selling: "Online-Verkauf",
      online_selling_desc: "Finden Sie unsere Produkte auf eBay und Wallapop für bequemes Einkaufen von zu Hause aus.",
      
      discover_products: "Produkte Entdecken",
      exclusive_collections: "Exklusive Sammlungen seit 1985",
      hero_main_title: "Modellbau, Pokemon und Sammlerstücke",
      hero_main_desc: "Weltweiter Versand — Sichere Zahlungen — Seltene Stücke",
      buy_now: "JETZT KAUFEN", discover_bestsellers: "Bestseller Entdecken", offers_this_week: "Angebote nur diese Woche gültig",
      explore_collections: "Sammlungen Entdecken", bestsellers_title: "Meistverkauft", bestsellers_desc: "Von unseren Kunden gewählt — Begrenzte Verfügbarkeit",
      view_all_catalog: "GESAMTEN KATALOG ANZEIGEN", limited_offer: "Begrenztes Angebot", weekly_promo: "Wochenangebot",
      weekly_promo_desc: "Reduzierter Versand + Rabatt auf das 3. Produkt — Nur diese Woche!",
      discover_offer: "ANGEBOT ENTDECKEN", insured_shipping: "Versicherter Versand", insured_shipping_desc: "Garantie bis €99 — Tracking immer inklusive",
      pay_installments: "In 3 Raten Zahlen", pay_installments_desc: "Mit Klarna — Zinsfrei", secure_payments: "100% Sichere Zahlungen",
      secure_payments_desc: "Karte, Überweisung, Klarna, Satispay",
      customer_reviews: "Was Unsere Kunden Sagen", verified_reviews: "Verifizierte Bewertungen", leave_review: "Bewertung Schreiben",
      close_form: "Schließen", no_reviews: "Noch keine Bewertungen — Seien Sie der Erste!", stay_updated: "Bleiben Sie Informiert",
      newsletter_desc: "Neuheiten, exklusive Angebote direkt in Ihre E-Mail", subscribe_now: "JETZT ABONNIEREN", sending: "Senden...",
      follow_social: "Folgen Sie uns", bestseller_badge: "BESTSELLER", preorder_badge: "VORBESTELLUNG", available: "Verfügbar",
      preorder_now: "Jetzt Vorbestellen", last_pieces: "Letzte", pieces: "Stück!", available_from: "Verfügbar ab",
      your_email: "Ihre E-Mail", your_name_opt: "Ihr Name (optional)", submit_review: "Bewertung Senden",
      name: "Name", email: "E-Mail", product: "Produkt", select_product: "Produkt auswählen...", rating: "Bewertung", comment: "Kommentar"
    },
    
    products: {
      title: "Unsere Produkte",
      subtitle: "Entdecken Sie unsere Sammlungen",
      catalog_updating: "Katalog wird Aktualisiert",
      catalog_updating_desc: "Wir aktualisieren unseren vollständigen Katalog. In der Zwischenzeit kontaktieren Sie uns für Informationen zu verfügbaren Produkten!",
      filter_category: "Nach Kategorie Filtern",
      all_categories: "Alle Kategorien",
      search_placeholder: "Produkte suchen...",
      sort_by: "Sortieren nach:",
      sort_newest: "Neueste",
      sort_price_low: "Preis: Niedrig bis Hoch",
      sort_price_high: "Preis: Hoch bis Niedrig",
      add_to_cart: "In den Warenkorb",
      request_info: "Info Anfragen",
      out_of_stock: "Ausverkauft",
      in_stock: "Verfügbar",
      call_us: "Rufen Sie Uns An"
    },
    
    product: {
      description: "Beschreibung",
      details: "Produktdetails",
      category: "Kategorie",
      price: "Preis",
      quantity: "Menge",
      add_to_cart: "In den Warenkorb",
      out_of_stock: "Produkt Ausverkauft",
      back_to_products: "Zurück zu Produkten"
    },
    
    cart: {
      title: "Warenkorb",
      empty: "Ihr Warenkorb ist leer",
      empty_desc: "Fügen Sie Produkte hinzu, um mit dem Einkaufen zu beginnen",
      continue_shopping: "Einkaufen Fortsetzen",
      product: "Produkt",
      quantity: "Menge",
      price: "Preis",
      total: "Gesamt",
      subtotal: "Zwischensumme",
      shipping: "Versand",
      order_total: "Bestellsumme",
      proceed_checkout: "Zur Kasse",
      remove: "Entfernen"
    },
    
    checkout: {
      title: "Kasse",
      customer_info: "Kundeninformationen",
      name: "Vollständiger Name",
      email: "E-Mail",
      phone: "Telefon",
      address: "Adresse",
      city: "Stadt",
      zip: "Postleitzahl",
      country: "Land",
      notes: "Notizen (optional)",
      payment_method: "Zahlungsmethode",
      cash_on_delivery: "Nachnahme",
      bank_transfer: "Banküberweisung",
      paypal: "PayPal",
      credit_card: "Kreditkarte/Stripe",
      place_order: "Bestellung Aufgeben",
      order_summary: "Bestellübersicht"
    },
    
    about: {
      title: "Über Uns",
      subtitle: "Unsere Geschichte und Leidenschaft",
      intro: "Unser Kiosk wird mit Leidenschaft von Cerasuolo Massimiliano und Rita Colarusso geführt, einer historischen Familie von Zeitungshändlern in Neapel mit jahrelanger Erfahrung in diesem Bereich.",
      specialization: "Wir sind spezialisiert auf F1-Modellbau der besten Verlage und Pokémon-Sammlungen und bieten unseren Kunden Qualitätsprodukte und persönlichen Service."
    },
    
    contact: {
      title: "Kontaktieren Sie Uns",
      subtitle: "Wir sind hier, um zu helfen",
      info: "Kontaktinformationen",
      address: "Adresse",
      address_value: "Corso Europa 175, 80010 Villaricca (NA)",
      phone: "Telefon",
      email: "E-Mail",
      hours: "Öffnungszeiten",
      monday_friday: "Montag - Freitag",
      saturday: "Samstag",
      sunday: "Sonntag",
      closed: "Geschlossen",
      send_message: "Nachricht Senden",
      your_name: "Ihr Name",
      your_email: "Ihre E-Mail",
      your_message: "Ihre Nachricht",
      send: "Senden"
    },
    
    footer: {
      copyright: "© 2024 Edicola Cerasuolo - Corso Europa 175, 80010 Villaricca (NA)",
      info: "Für Produktinformationen"
    },
    
    common: {
      loading: "Laden...",
      error: "Fehler",
      success: "Erfolg",
      close: "Schließen",
      save: "Speichern",
      cancel: "Abbrechen",
      delete: "Löschen",
      edit: "Bearbeiten",
      view: "Ansehen",
      search: "Suchen",
      filter: "Filtern",
      sort: "Sortieren"
    }
  },
  
  es: {
    nav: {
      home: "Inicio",
      products: "Productos",
      about: "Sobre Nosotros",
      contact: "Contacto",
      terms: "Términos y Condiciones",
      management: "Gestión",
      cart: "Carrito",
      login: "Iniciar Sesión",
      logout: "Cerrar Sesión"
    },
    
    home: {
      hero_title: "Bienvenidos a Edicola Cerasuolo",
      hero_subtitle: "Modelismo F1, Pokémon TCG y Coleccionables de Calidad",
      hero_description: "Descubre nuestra selección de modelos F1, Pokémon TCG y colecciones especiales",
      shop_now: "Ver Productos",
      contact_us: "Contáctanos",
      
      secure_shipping: "ENVÍO ASEGURADO",
      secure_shipping_desc: "Garantizado hasta 99€ - Más de 99€ a cargo del cliente",
      pay_3_installments: "PAGA EN 3 CUOTAS",
      pay_3_installments_desc: "¡Sin intereses, sin costes adicionales!",
      paypal_3_rates: "PayPal - Paga en 3 Cuotas",
      
      presale_title: "Productos en Preventa",
      presale_desc: "Reserva ahora las próximas llegadas con ventajas exclusivas",
      presale_price: "Precio rebajado",
      presale_delivery: "Entrega garantizada",
      presale_btn: "Descubrir Preventas",
      
      reservation_title: "Productos en Reserva",
      reservation_desc: "Asegúrate tus coleccionables favoritos",
      reservation_free: "Reserva gratuita",
      reservation_notify: "Notificación de disponibilidad",
      reservation_btn: "Ver Reservas",
      
      online_sale: "Venta Online",
      online_sale_desc: "Navega por nuestro catálogo y elige los productos que te interesan",
      go_to_products: "Ir a Productos",
      
      payment_methods: "Métodos de Pago",
      payment_methods_desc: "Elige el método más cómodo para ti",
      bank_transfer: "Transferencia Bancaria",
      credit_card: "Tarjeta de Crédito",
      paypal: "PayPal",
      klarna_3: "Klarna 3 Cuotas",
      
      about_title: "Sobre Nosotros",
      about_desc: "Nuestro quiosco está gestionado con pasión por Cerasuolo Massimiliano y Rita Colarusso, familia histórica de quiosqueros en Nápoles con años de experiencia en el sector.",
      about_more: "Más sobre nosotros",
      
      f1_modeling: "Modelismo F1",
      f1_modeling_desc: "Los grandes Ferrari, McLaren, Mercedes y todas las escuderías históricas. Modelos a escala de las mejores editoriales.",
      pokemon_tcg: "Pokémon TCG",
      pokemon_tcg_desc: "Mystery Box, cartas raras, colecciones especiales y todos los productos oficiales del Trading Card Game.",
      online_selling: "Venta Online",
      online_selling_desc: "Encuentra nuestros productos en eBay y Wallapop para compras cómodas desde casa.",
      
      discover_products: "Descubrir Productos",
      exclusive_collections: "Colecciones Exclusivas desde 1985",
      hero_main_title: "Modelismo, Pokemon y Coleccionables",
      hero_main_desc: "Envíos a todo el mundo — Pagos seguros — Piezas raras",
      buy_now: "COMPRAR AHORA", discover_bestsellers: "Descubrir Bestsellers", offers_this_week: "Ofertas válidas solo esta semana",
      explore_collections: "Explorar Colecciones", bestsellers_title: "Los Más Vendidos", bestsellers_desc: "Elegidos por nuestros clientes — Disponibilidad limitada",
      view_all_catalog: "VER TODO EL CATÁLOGO", limited_offer: "Oferta Limitada", weekly_promo: "Promo Semanal",
      weekly_promo_desc: "Envío reducido + descuento en el 3er producto — ¡Solo esta semana!",
      discover_offer: "DESCUBRIR LA OFERTA", insured_shipping: "Envío Asegurado", insured_shipping_desc: "Garantía hasta €99 — Seguimiento incluido",
      pay_installments: "Paga en 3 Cuotas", pay_installments_desc: "Con Klarna — Sin intereses",
      secure_payments: "Pagos 100% Seguros", secure_payments_desc: "Tarjeta, Transferencia, Klarna, Satispay",
      customer_reviews: "Lo que Dicen Nuestros Clientes", verified_reviews: "Reseñas verificadas",
      leave_review: "Dejar una Reseña", close_form: "Cerrar", no_reviews: "Sin reseñas aún — ¡Sé el primero!",
      stay_updated: "Mantente Informado", newsletter_desc: "Novedades y ofertas exclusivas en tu email",
      subscribe_now: "SUSCRÍBETE AHORA", sending: "Enviando...", follow_social: "Síguenos",
      bestseller_badge: "BESTSELLER", preorder_badge: "PREVENTA", available: "Disponible", preorder_now: "Reserva ahora",
      last_pieces: "Últimas", pieces: "unidades!", available_from: "Disponible desde",
      your_email: "Tu email", your_name_opt: "Tu nombre (opcional)", submit_review: "Enviar Reseña",
      name: "Nombre", email: "Email", product: "Producto", select_product: "Seleccionar producto...", rating: "Valoración", comment: "Comentario"
    },
    
    products: {
      title: "Nuestros Productos",
      subtitle: "Descubre nuestras colecciones",
      catalog_updating: "Catálogo en Actualización",
      catalog_updating_desc: "Estamos cargando nuestro catálogo completo. ¡Mientras tanto, contáctanos para información sobre productos disponibles!",
      filter_category: "Filtrar por Categoría",
      all_categories: "Todas las Categorías",
      search_placeholder: "Buscar productos...",
      sort_by: "Ordenar por:",
      sort_newest: "Más Recientes",
      sort_price_low: "Precio: Bajo a Alto",
      sort_price_high: "Precio: Alto a Bajo",
      add_to_cart: "Añadir al Carrito",
      request_info: "Solicitar Info",
      out_of_stock: "Agotado",
      in_stock: "Disponible",
      call_us: "Llámanos"
    },
    
    product: {
      description: "Descripción",
      details: "Detalles del Producto",
      category: "Categoría",
      price: "Precio",
      quantity: "Cantidad",
      add_to_cart: "Añadir al Carrito",
      out_of_stock: "Producto Agotado",
      back_to_products: "Volver a Productos"
    },
    
    cart: {
      title: "Carrito",
      empty: "Tu carrito está vacío",
      empty_desc: "Añade productos para empezar a comprar",
      continue_shopping: "Continuar Comprando",
      product: "Producto",
      quantity: "Cantidad",
      price: "Precio",
      total: "Total",
      subtotal: "Subtotal",
      shipping: "Envío",
      order_total: "Total Pedido",
      proceed_checkout: "Proceder al Pago",
      remove: "Eliminar"
    },
    
    checkout: {
      title: "Finalizar Compra",
      customer_info: "Información del Cliente",
      name: "Nombre Completo",
      email: "Email",
      phone: "Teléfono",
      address: "Dirección",
      city: "Ciudad",
      zip: "Código Postal",
      country: "País",
      notes: "Notas (opcional)",
      payment_method: "Método de Pago",
      cash_on_delivery: "Contrareembolso",
      bank_transfer: "Transferencia Bancaria",
      paypal: "PayPal",
      credit_card: "Tarjeta de Crédito/Stripe",
      place_order: "Confirmar Pedido",
      order_summary: "Resumen del Pedido"
    },
    
    about: {
      title: "Sobre Nosotros",
      subtitle: "Nuestra historia y pasión",
      intro: "Nuestro quiosco está gestionado con pasión por Cerasuolo Massimiliano y Rita Colarusso, familia histórica de quiosqueros en Nápoles con años de experiencia en el sector.",
      specialization: "Nos especializamos en modelismo F1 de las mejores editoriales y colecciones Pokémon, ofreciendo a nuestros clientes productos de calidad y servicio personalizado."
    },
    
    contact: {
      title: "Contáctanos",
      subtitle: "Estamos aquí para ayudarte",
      info: "Información de Contacto",
      address: "Dirección",
      address_value: "Corso Europa 175, 80010 Villaricca (NA)",
      phone: "Teléfono",
      email: "Email",
      hours: "Horario de Apertura",
      monday_friday: "Lunes - Viernes",
      saturday: "Sábado",
      sunday: "Domingo",
      closed: "Cerrado",
      send_message: "Enviar Mensaje",
      your_name: "Tu nombre",
      your_email: "Tu email",
      your_message: "Tu mensaje",
      send: "Enviar"
    },
    
    footer: {
      copyright: "© 2024 Edicola Cerasuolo - Corso Europa 175, 80010 Villaricca (NA)",
      info: "Para información sobre productos"
    },
    
    common: {
      loading: "Cargando...",
      error: "Error",
      success: "Éxito",
      close: "Cerrar",
      save: "Guardar",
      cancel: "Cancelar",
      delete: "Eliminar",
      edit: "Editar",
      view: "Ver",
      search: "Buscar",
      filter: "Filtrar",
      sort: "Ordenar"
    }
  },
  
  pt: {
    nav: {
      home: "Início",
      products: "Produtos",
      about: "Sobre Nós",
      contact: "Contato",
      terms: "Termos e Condições",
      management: "Gestão",
      cart: "Carrinho",
      login: "Entrar",
      logout: "Sair"
    },
    
    home: {
      hero_title: "Bem-vindos à Edicola Cerasuolo",
      hero_subtitle: "Modelismo F1, Pokémon TCG e Colecionáveis de Qualidade",
      hero_description: "Descubra nossa seleção de modelos F1, Pokémon TCG e coleções especiais",
      shop_now: "Ver Produtos",
      contact_us: "Entre em Contato",
      
      secure_shipping: "ENVIO SEGURADO",
      secure_shipping_desc: "Garantido até €99 - Acima de €99 por conta do cliente",
      pay_3_installments: "PAGUE EM 3 VEZES",
      pay_3_installments_desc: "Sem juros, sem custos adicionais!",
      paypal_3_rates: "PayPal - Pague em 3 Vezes",
      
      presale_title: "Produtos em Pré-venda",
      presale_desc: "Reserve agora as próximas chegadas com vantagens exclusivas",
      presale_price: "Preço reduzido",
      presale_delivery: "Entrega garantida",
      presale_btn: "Descubra Pré-vendas",
      
      reservation_title: "Produtos em Reserva",
      reservation_desc: "Garanta seus colecionáveis favoritos",
      reservation_free: "Reserva gratuita",
      reservation_notify: "Notificação de disponibilidade",
      reservation_btn: "Ver Reservas",
      
      online_sale: "Venda Online",
      online_sale_desc: "Navegue pelo nosso catálogo e escolha os produtos que lhe interessam",
      go_to_products: "Ir para Produtos",
      
      payment_methods: "Métodos de Pagamento",
      payment_methods_desc: "Escolha o método mais conveniente para você",
      bank_transfer: "Transferência Bancária",
      credit_card: "Cartão de Crédito",
      paypal: "PayPal",
      klarna_3: "Klarna 3 Parcelas",
      
      about_title: "Sobre Nós",
      about_desc: "Nossa banca é gerida com paixão por Cerasuolo Massimiliano e Rita Colarusso, família histórica de jornaleiros em Nápoles com anos de experiência no setor.",
      about_more: "Saiba mais sobre nós",
      
      f1_modeling: "Modelismo F1",
      f1_modeling_desc: "As grandes Ferrari, McLaren, Mercedes e todas as equipes históricas. Modelos em escala das melhores editoras.",
      pokemon_tcg: "Pokémon TCG",
      pokemon_tcg_desc: "Mystery Box, cartas raras, coleções especiais e todos os produtos oficiais do Trading Card Game.",
      online_selling: "Venda Online",
      online_selling_desc: "Encontre nossos produtos no eBay e Wallapop para compras convenientes de casa.",
      
      discover_products: "Descobrir Produtos",
      exclusive_collections: "Coleções Exclusivas desde 1985", hero_main_title: "Modelismo, Pokemon e Colecionáveis",
      hero_main_desc: "Envios para todo o mundo — Pagamentos seguros — Peças raras",
      buy_now: "COMPRAR AGORA", discover_bestsellers: "Descubrir Bestsellers", offers_this_week: "Ofertas válidas apenas esta semana",
      explore_collections: "Explorar Coleções", bestsellers_title: "Mais Vendidos", bestsellers_desc: "Escolhidos pelos nossos clientes",
      view_all_catalog: "VER TODO O CATÁLOGO", limited_offer: "Oferta Limitada", weekly_promo: "Promo Semanal",
      weekly_promo_desc: "Envio reduzido + desconto no 3º produto — Apenas esta semana!",
      discover_offer: "DESCOBRIR A OFERTA", insured_shipping: "Envio Segurado", insured_shipping_desc: "Garantia até €99",
      pay_installments: "Pague em 3x", pay_installments_desc: "Com Klarna — Sem juros",
      secure_payments: "Pagamentos 100% Seguros", secure_payments_desc: "Cartão, Transferência, Klarna, Satispay",
      customer_reviews: "O que Dizem os Nossos Clientes", verified_reviews: "Avaliações verificadas",
      leave_review: "Deixar Avaliação", close_form: "Fechar", no_reviews: "Sem avaliações — Seja o primeiro!",
      stay_updated: "Fique Atualizado", newsletter_desc: "Novidades e ofertas exclusivas no seu email",
      subscribe_now: "INSCREVA-SE AGORA", sending: "Enviando...", follow_social: "Siga-nos",
      bestseller_badge: "BESTSELLER", preorder_badge: "PRÉ-VENDA", available: "Disponível", preorder_now: "Reserve agora",
      last_pieces: "Últimas", pieces: "unidades!", available_from: "Disponível a partir de",
      your_email: "Seu email", your_name_opt: "Seu nome (opcional)", submit_review: "Enviar Avaliação",
      name: "Nome", email: "Email", product: "Produto", select_product: "Selecionar produto...", rating: "Avaliação", comment: "Comentário"
    },
    
    products: {
      title: "Nossos Produtos",
      subtitle: "Descubra nossas coleções",
      catalog_updating: "Catálogo em Atualização",
      catalog_updating_desc: "Estamos carregando nosso catálogo completo. Enquanto isso, entre em contato para informações sobre produtos disponíveis!",
      filter_category: "Filtrar por Categoria",
      all_categories: "Todas as Categorias",
      search_placeholder: "Pesquisar produtos...",
      sort_by: "Ordenar por:",
      sort_newest: "Mais Recentes",
      sort_price_low: "Preço: Baixo a Alto",
      sort_price_high: "Preço: Alto a Baixo",
      add_to_cart: "Adicionar ao Carrinho",
      request_info: "Solicitar Info",
      out_of_stock: "Esgotado",
      in_stock: "Disponível",
      call_us: "Ligue-nos"
    },
    
    product: {
      description: "Descrição",
      details: "Detalhes do Produto",
      category: "Categoria",
      price: "Preço",
      quantity: "Quantidade",
      add_to_cart: "Adicionar ao Carrinho",
      out_of_stock: "Produto Esgotado",
      back_to_products: "Voltar aos Produtos"
    },
    
    cart: {
      title: "Carrinho",
      empty: "Seu carrinho está vazio",
      empty_desc: "Adicione produtos para começar a comprar",
      continue_shopping: "Continuar Comprando",
      product: "Produto",
      quantity: "Quantidade",
      price: "Preço",
      total: "Total",
      subtotal: "Subtotal",
      shipping: "Envio",
      order_total: "Total do Pedido",
      proceed_checkout: "Finalizar Compra",
      remove: "Remover"
    },
    
    checkout: {
      title: "Finalizar Compra",
      customer_info: "Informações do Cliente",
      name: "Nome Completo",
      email: "Email",
      phone: "Telefone",
      address: "Endereço",
      city: "Cidade",
      zip: "CEP",
      country: "País",
      notes: "Notas (opcional)",
      payment_method: "Método de Pagamento",
      cash_on_delivery: "Pagamento na Entrega",
      bank_transfer: "Transferência Bancária",
      paypal: "PayPal",
      credit_card: "Cartão de Crédito/Stripe",
      place_order: "Confirmar Pedido",
      order_summary: "Resumo do Pedido"
    },
    
    about: {
      title: "Sobre Nós",
      subtitle: "Nossa história e paixão",
      intro: "Nossa banca é gerida com paixão por Cerasuolo Massimiliano e Rita Colarusso, família histórica de jornaleiros em Nápoles com anos de experiência no setor.",
      specialization: "Somos especializados em modelismo F1 das melhores editoras e coleções Pokémon, oferecendo aos nossos clientes produtos de qualidade e serviço personalizado."
    },
    
    contact: {
      title: "Entre em Contato",
      subtitle: "Estamos aqui para ajudar",
      info: "Informações de Contato",
      address: "Endereço",
      address_value: "Corso Europa 175, 80010 Villaricca (NA)",
      phone: "Telefone",
      email: "Email",
      hours: "Horário de Funcionamento",
      monday_friday: "Segunda - Sexta",
      saturday: "Sábado",
      sunday: "Domingo",
      closed: "Fechado",
      send_message: "Enviar Mensagem",
      your_name: "Seu nome",
      your_email: "Seu email",
      your_message: "Sua mensagem",
      send: "Enviar"
    },
    
    footer: {
      copyright: "© 2024 Edicola Cerasuolo - Corso Europa 175, 80010 Villaricca (NA)",
      info: "Para informações sobre produtos"
    },
    
    common: {
      loading: "Carregando...",
      error: "Erro",
      success: "Sucesso",
      close: "Fechar",
      save: "Salvar",
      cancel: "Cancelar",
      delete: "Excluir",
      edit: "Editar",
      view: "Ver",
      search: "Pesquisar",
      filter: "Filtrar",
      sort: "Ordenar"
    }
  },
  
  pl: {
    nav: {
      home: "Strona Główna",
      products: "Produkty",
      about: "O Nas",
      contact: "Kontakt",
      terms: "Regulamin",
      management: "Zarządzanie",
      cart: "Koszyk",
      login: "Zaloguj",
      logout: "Wyloguj"
    },
    
    home: {
      hero_title: "Witamy w Edicola Cerasuolo",
      hero_subtitle: "Modelarstwo F1, Pokémon TCG i Wysokiej Jakości Kolekcje",
      hero_description: "Odkryj naszą selekcję modeli F1, Pokémon TCG i kolekcji specjalnych",
      shop_now: "Zobacz Produkty",
      contact_us: "Skontaktuj się",
      
      secure_shipping: "UBEZPIECZONA DOSTAWA",
      secure_shipping_desc: "Gwarantowana do 99€ - Powyżej 99€ na koszt klienta",
      pay_3_installments: "ZAPŁAĆ W 3 RATACH",
      pay_3_installments_desc: "Bez odsetek, bez dodatkowych kosztów!",
      paypal_3_rates: "PayPal - Zapłać w 3 Ratach",
      
      presale_title: "Produkty w Przedsprzedaży",
      presale_desc: "Zamów nadchodzące produkty z ekskluzywnymi korzyściami",
      presale_price: "Obniżona cena",
      presale_delivery: "Gwarantowana dostawa",
      presale_btn: "Odkryj Przedsprzedaże",
      
      reservation_title: "Produkty do Rezerwacji",
      reservation_desc: "Zabezpiecz swoje ulubione przedmioty kolekcjonerskie",
      reservation_free: "Darmowa rezerwacja",
      reservation_notify: "Powiadomienie o dostępności",
      reservation_btn: "Zobacz Rezerwacje",
      
      online_sale: "Sprzedaż Online",
      online_sale_desc: "Przeglądaj nasz katalog i wybierz produkty, które Cię interesują",
      go_to_products: "Przejdź do Produktów",
      
      payment_methods: "Metody Płatności",
      payment_methods_desc: "Wybierz najbardziej dogodną metodę",
      bank_transfer: "Przelew Bankowy",
      credit_card: "Karta Kredytowa",
      paypal: "PayPal",
      klarna_3: "Klarna 3 Raty",
      
      about_title: "O Nas",
      about_desc: "Nasz kiosk jest prowadzony z pasją przez Cerasuolo Massimiliano i Ritę Colarusso, historyczną rodzinę sprzedawców gazet w Neapolu z wieloletnim doświadczeniem w branży.",
      about_more: "Dowiedz się więcej o nas",
      
      f1_modeling: "Modelarstwo F1",
      f1_modeling_desc: "Wielkie Ferrari, McLareny, Mercedesy i wszystkie historyczne zespoły. Modele w skali od najlepszych wydawców.",
      pokemon_tcg: "Pokémon TCG",
      pokemon_tcg_desc: "Mystery Boxy, rzadkie karty, kolekcje specjalne i wszystkie oficjalne produkty Trading Card Game.",
      online_selling: "Sprzedaż Online",
      online_selling_desc: "Znajdź nasze produkty na eBay i Wallapop dla wygodnych zakupów z domu.",
      
      discover_products: "Odkryj Produkty",
      exclusive_collections: "Ekskluzywne Kolekcje od 1985", hero_main_title: "Modelarstwo, Pokemon i Kolekcje",
      hero_main_desc: "Wysyłka na cały świat — Bezpieczne płatności — Rzadkie egzemplarze",
      buy_now: "KUP TERAZ", discover_bestsellers: "Odkryj Bestsellery", offers_this_week: "Oferty ważne tylko w tym tygodniu",
      explore_collections: "Przeglądaj Kolekcje", bestsellers_title: "Najczęściej Kupowane", bestsellers_desc: "Wybrane przez naszych klientów",
      view_all_catalog: "ZOBACZ CAŁY KATALOG", limited_offer: "Oferta Limitowana", weekly_promo: "Promocja Tygodnia",
      weekly_promo_desc: "Obniżona wysyłka + rabat na 3. produkt — Tylko w tym tygodniu!",
      discover_offer: "ODKRYJ OFERTĘ", insured_shipping: "Ubezpieczona Wysyłka", insured_shipping_desc: "Gwarancja do €99",
      pay_installments: "Płać w 3 Ratach", pay_installments_desc: "Z Klarna — Bez odsetek",
      secure_payments: "100% Bezpieczne Płatności", secure_payments_desc: "Karta, Przelew, Klarna, Satispay",
      customer_reviews: "Co Mówią Nasi Klienci", verified_reviews: "Zweryfikowane opinie",
      leave_review: "Zostaw Opinię", close_form: "Zamknij", no_reviews: "Brak opinii — Bądź pierwszy!",
      stay_updated: "Bądź na Bieżąco", newsletter_desc: "Nowości i ekskluzywne oferty na Twój email",
      subscribe_now: "ZAPISZ SIĘ TERAZ", sending: "Wysyłanie...", follow_social: "Śledź nas",
      bestseller_badge: "BESTSELLER", preorder_badge: "PRZEDSPRZEDAŻ", available: "Dostępny", preorder_now: "Zamów teraz",
      last_pieces: "Ostatnie", pieces: "sztuk!", available_from: "Dostępny od",
      your_email: "Twój email", your_name_opt: "Twoje imię (opcjonalnie)", submit_review: "Wyślij Opinię",
      name: "Imię", email: "Email", product: "Produkt", select_product: "Wybierz produkt...", rating: "Ocena", comment: "Komentarz"
    },
    
    products: {
      title: "Nasze Produkty",
      subtitle: "Odkryj nasze kolekcje",
      catalog_updating: "Katalog w Aktualizacji",
      catalog_updating_desc: "Aktualizujemy nasz kompletny katalog. W międzyczasie skontaktuj się z nami po informacje o dostępnych produktach!",
      filter_category: "Filtruj według Kategorii",
      all_categories: "Wszystkie Kategorie",
      search_placeholder: "Szukaj produktów...",
      sort_by: "Sortuj według:",
      sort_newest: "Najnowsze",
      sort_price_low: "Cena: Niska do Wysokiej",
      sort_price_high: "Cena: Wysoka do Niskiej",
      add_to_cart: "Dodaj do Koszyka",
      request_info: "Zapytaj o Info",
      out_of_stock: "Wyprzedane",
      in_stock: "Dostępne",
      call_us: "Zadzwoń do Nas"
    },
    
    product: {
      description: "Opis",
      details: "Szczegóły Produktu",
      category: "Kategoria",
      price: "Cena",
      quantity: "Ilość",
      add_to_cart: "Dodaj do Koszyka",
      out_of_stock: "Produkt Wyprzedany",
      back_to_products: "Powrót do Produktów"
    },
    
    cart: {
      title: "Koszyk",
      empty: "Twój koszyk jest pusty",
      empty_desc: "Dodaj produkty, aby rozpocząć zakupy",
      continue_shopping: "Kontynuuj Zakupy",
      product: "Produkt",
      quantity: "Ilość",
      price: "Cena",
      total: "Suma",
      subtotal: "Suma Częściowa",
      shipping: "Dostawa",
      order_total: "Suma Zamówienia",
      proceed_checkout: "Przejdź do Kasy",
      remove: "Usuń"
    },
    
    checkout: {
      title: "Finalizacja",
      customer_info: "Informacje o Kliencie",
      name: "Imię i Nazwisko",
      email: "Email",
      phone: "Telefon",
      address: "Adres",
      city: "Miasto",
      zip: "Kod Pocztowy",
      country: "Kraj",
      notes: "Uwagi (opcjonalne)",
      payment_method: "Metoda Płatności",
      cash_on_delivery: "Płatność przy Odbiorze",
      bank_transfer: "Przelew Bankowy",
      paypal: "PayPal",
      credit_card: "Karta Kredytowa/Stripe",
      place_order: "Złóż Zamówienie",
      order_summary: "Podsumowanie Zamówienia"
    },
    
    about: {
      title: "O Nas",
      subtitle: "Nasza historia i pasja",
      intro: "Nasz kiosk jest prowadzony z pasją przez Cerasuolo Massimiliano i Ritę Colarusso, historyczną rodzinę sprzedawców gazet w Neapolu z wieloletnim doświadczeniem w branży.",
      specialization: "Specjalizujemy się w modelarstwie F1 od najlepszych wydawców i kolekcjach Pokémon, oferując naszym klientom produkty wysokiej jakości i spersonalizowaną obsługę."
    },
    
    contact: {
      title: "Kontakt",
      subtitle: "Jesteśmy tu, aby pomóc",
      info: "Informacje Kontaktowe",
      address: "Adres",
      address_value: "Corso Europa 175, 80010 Villaricca (NA)",
      phone: "Telefon",
      email: "Email",
      hours: "Godziny Otwarcia",
      monday_friday: "Poniedziałek - Piątek",
      saturday: "Sobota",
      sunday: "Niedziela",
      closed: "Zamknięte",
      send_message: "Wyślij Wiadomość",
      your_name: "Twoje imię",
      your_email: "Twój email",
      your_message: "Twoja wiadomość",
      send: "Wyślij"
    },
    
    footer: {
      copyright: "© 2024 Edicola Cerasuolo - Corso Europa 175, 80010 Villaricca (NA)",
      info: "Informacje o produktach"
    },
    
    common: {
      loading: "Ładowanie...",
      error: "Błąd",
      success: "Sukces",
      close: "Zamknij",
      save: "Zapisz",
      cancel: "Anuluj",
      delete: "Usuń",
      edit: "Edytuj",
      view: "Zobacz",
      search: "Szukaj",
      filter: "Filtruj",
      sort: "Sortuj"
    }
  },
  
  ro: {
    nav: {
      home: "Acasă",
      products: "Produse",
      about: "Despre Noi",
      contact: "Contact",
      terms: "Termeni și Condiții",
      management: "Management",
      cart: "Coș",
      login: "Autentificare",
      logout: "Deconectare"
    },
    
    home: {
      hero_title: "Bun venit la Edicola Cerasuolo",
      hero_subtitle: "Modele F1, Pokémon TCG și Colecționabile de Calitate",
      hero_description: "Descoperă selecția noastră de modele F1, Pokémon TCG și colecții speciale",
      shop_now: "Vezi Produsele",
      contact_us: "Contactează-ne",
      
      secure_shipping: "LIVRARE ASIGURATĂ",
      secure_shipping_desc: "Garantată până la 99€ - Peste 99€ în sarcina clientului",
      pay_3_installments: "PLĂTEȘTE ÎN 3 RATE",
      pay_3_installments_desc: "Fără dobândă, fără costuri suplimentare!",
      paypal_3_rates: "PayPal - Plătește în 3 Rate",
      
      presale_title: "Produse în Prevânzare",
      presale_desc: "Precomandă sosirile viitoare cu avantaje exclusive",
      presale_price: "Preț redus",
      presale_delivery: "Livrare garantată",
      presale_btn: "Descoperă Prevânzările",
      
      reservation_title: "Produse în Rezervare",
      reservation_desc: "Asigură-ți colecționabilele favorite",
      reservation_free: "Rezervare gratuită",
      reservation_notify: "Notificare de disponibilitate",
      reservation_btn: "Vezi Rezervările",
      
      online_sale: "Vânzare Online",
      online_sale_desc: "Răsfoiește catalogul nostru și alege produsele care te interesează",
      go_to_products: "Mergi la Produse",
      
      payment_methods: "Metode de Plată",
      payment_methods_desc: "Alege metoda cea mai convenabilă pentru tine",
      bank_transfer: "Transfer Bancar",
      credit_card: "Card de Credit",
      paypal: "PayPal",
      klarna_3: "Klarna 3 Rate",
      
      about_title: "Despre Noi",
      about_desc: "Chioșcul nostru este gestionat cu pasiune de Cerasuolo Massimiliano și Rita Colarusso, familie istorică de vânzători de ziare în Napoli cu ani de experiență în sector.",
      about_more: "Află mai multe despre noi",
      
      f1_modeling: "Modele F1",
      f1_modeling_desc: "Marile Ferrari, McLaren, Mercedes și toate echipele istorice. Modele la scară de la cei mai buni editori.",
      pokemon_tcg: "Pokémon TCG",
      pokemon_tcg_desc: "Mystery Box, cărți rare, colecții speciale și toate produsele oficiale Trading Card Game.",
      online_selling: "Vânzare Online",
      online_selling_desc: "Găsește produsele noastre pe eBay și Wallapop pentru cumpărături convenabile de acasă.",
      
      discover_products: "Descoperă Produsele",
      exclusive_collections: "Colecții Exclusive din 1985", hero_main_title: "Modelism, Pokemon și Colecționabile",
      hero_main_desc: "Livrări în toată lumea — Plăți sigure — Piese rare", buy_now: "CUMPĂRĂ ACUM",
      discover_bestsellers: "Descoperă Bestsellerele", offers_this_week: "Oferte valabile doar săptămâna aceasta",
      explore_collections: "Explorează Colecțiile", bestsellers_title: "Cele Mai Vândute", bestsellers_desc: "Alese de clienții noștri",
      view_all_catalog: "VEZI TOT CATALOGUL", limited_offer: "Ofertă Limitată", weekly_promo: "Promoția Săptămânii",
      weekly_promo_desc: "Livrare redusă + reducere la al 3-lea produs!", discover_offer: "DESCOPERĂ OFERTA",
      insured_shipping: "Livrare Asigurată", insured_shipping_desc: "Garanție până la €99",
      pay_installments: "Plătește în 3 Rate", pay_installments_desc: "Cu Klarna — Fără dobândă",
      secure_payments: "Plăți 100% Sigure", secure_payments_desc: "PayPal, Card, Transfer, Satispay",
      customer_reviews: "Ce Spun Clienții Noștri", verified_reviews: "Recenzii verificate",
      leave_review: "Lasă o Recenzie", close_form: "Închide", no_reviews: "Fără recenzii — Fii primul!",
      stay_updated: "Rămâi Informat", newsletter_desc: "Noutăți și oferte exclusive pe email",
      subscribe_now: "ABONEAZĂ-TE ACUM", sending: "Se trimite...", follow_social: "Urmărește-ne",
      bestseller_badge: "BESTSELLER", preorder_badge: "PRECOMANADĂ", available: "Disponibil", preorder_now: "Precomandă acum",
      last_pieces: "Ultimele", pieces: "bucăți!", available_from: "Disponibil din",
      your_email: "Emailul tău", your_name_opt: "Numele tău (opțional)", submit_review: "Trimite Recenzia",
      name: "Nume", email: "Email", product: "Produs", select_product: "Selectează produs...", rating: "Evaluare", comment: "Comentariu"
    },
    
    products: {
      title: "Produsele Noastre",
      subtitle: "Descoperă colecțiile noastre",
      catalog_updating: "Catalog în Actualizare",
      catalog_updating_desc: "Încărcăm catalogul nostru complet. Între timp, contactează-ne pentru informații despre produsele disponibile!",
      filter_category: "Filtrează după Categorie",
      all_categories: "Toate Categoriile",
      search_placeholder: "Caută produse...",
      sort_by: "Sortează după:",
      sort_newest: "Cele Mai Noi",
      sort_price_low: "Preț: Mic la Mare",
      sort_price_high: "Preț: Mare la Mic",
      add_to_cart: "Adaugă în Coș",
      request_info: "Solicită Info",
      out_of_stock: "Stoc Epuizat",
      in_stock: "Disponibil",
      call_us: "Sună-ne"
    },
    
    product: {
      description: "Descriere",
      details: "Detalii Produs",
      category: "Categorie",
      price: "Preț",
      quantity: "Cantitate",
      add_to_cart: "Adaugă în Coș",
      out_of_stock: "Produs Epuizat",
      back_to_products: "Înapoi la Produse"
    },
    
    cart: {
      title: "Coș",
      empty: "Coșul tău este gol",
      empty_desc: "Adaugă produse pentru a începe cumpărăturile",
      continue_shopping: "Continuă Cumpărăturile",
      product: "Produs",
      quantity: "Cantitate",
      price: "Preț",
      total: "Total",
      subtotal: "Subtotal",
      shipping: "Livrare",
      order_total: "Total Comandă",
      proceed_checkout: "Continuă la Plată",
      remove: "Elimină"
    },
    
    checkout: {
      title: "Finalizare Comandă",
      customer_info: "Informații Client",
      name: "Nume Complet",
      email: "Email",
      phone: "Telefon",
      address: "Adresă",
      city: "Oraș",
      zip: "Cod Poștal",
      country: "Țară",
      notes: "Note (opțional)",
      payment_method: "Metodă de Plată",
      cash_on_delivery: "Plată la Livrare",
      bank_transfer: "Transfer Bancar",
      paypal: "PayPal",
      credit_card: "Card de Credit/Stripe",
      place_order: "Plasează Comanda",
      order_summary: "Sumar Comandă"
    },
    
    about: {
      title: "Despre Noi",
      subtitle: "Povestea și pasiunea noastră",
      intro: "Chioșcul nostru este gestionat cu pasiune de Cerasuolo Massimiliano și Rita Colarusso, familie istorică de vânzători de ziare în Napoli cu ani de experiență în sector.",
      specialization: "Ne specializăm în modele F1 de la cei mai buni editori și colecții Pokémon, oferind clienților noștri produse de calitate și servicii personalizate."
    },
    
    contact: {
      title: "Contactează-ne",
      subtitle: "Suntem aici să te ajutăm",
      info: "Informații de Contact",
      address: "Adresă",
      address_value: "Corso Europa 175, 80010 Villaricca (NA)",
      phone: "Telefon",
      email: "Email",
      hours: "Program",
      monday_friday: "Luni - Vineri",
      saturday: "Sâmbătă",
      sunday: "Duminică",
      closed: "Închis",
      send_message: "Trimite Mesaj",
      your_name: "Numele tău",
      your_email: "Email-ul tău",
      your_message: "Mesajul tău",
      send: "Trimite"
    },
    
    footer: {
      copyright: "© 2024 Edicola Cerasuolo - Corso Europa 175, 80010 Villaricca (NA)",
      info: "Pentru informații despre produse"
    },
    
    common: {
      loading: "Se încarcă...",
      error: "Eroare",
      success: "Succes",
      close: "Închide",
      save: "Salvează",
      cancel: "Anulează",
      delete: "Șterge",
      edit: "Editează",
      view: "Vezi",
      search: "Caută",
      filter: "Filtrează",
      sort: "Sortează"
    }
  },
  
  nl: {
    nav: {
      home: "Home",
      products: "Producten",
      about: "Over Ons",
      contact: "Contact",
      terms: "Voorwaarden",
      management: "Beheer",
      cart: "Winkelwagen",
      login: "Inloggen",
      logout: "Uitloggen"
    },
    
    home: {
      hero_title: "Welkom bij Edicola Cerasuolo",
      hero_subtitle: "F1 Modelbouw, Pokémon TCG en Kwaliteit Verzamelobjecten",
      hero_description: "Ontdek onze selectie F1 modellen, Pokémon TCG en speciale collecties",
      shop_now: "Bekijk Producten",
      contact_us: "Neem Contact Op",
      
      secure_shipping: "VERZEKERDE VERZENDING",
      secure_shipping_desc: "Gegarandeerd tot €99 - Boven €99 voor rekening van klant",
      pay_3_installments: "BETAAL IN 3 TERMIJNEN",
      pay_3_installments_desc: "Rentevrij, geen extra kosten!",
      paypal_3_rates: "PayPal - Betaal in 3 Termijnen",
      
      presale_title: "Producten in Voorverkoop",
      presale_desc: "Reserveer nu komende artikelen met exclusieve voordelen",
      presale_price: "Gereduceerde prijs",
      presale_delivery: "Gegarandeerde levering",
      presale_btn: "Ontdek Voorverkoop",
      
      reservation_title: "Reserveringsproducten",
      reservation_desc: "Verzeker je favoriete verzamelobjecten",
      reservation_free: "Gratis reservering",
      reservation_notify: "Beschikbaarheidsmelding",
      reservation_btn: "Bekijk Reserveringen",
      
      online_sale: "Online Verkoop",
      online_sale_desc: "Blader door onze catalogus en kies de producten die je interesseren",
      go_to_products: "Ga naar Producten",
      
      payment_methods: "Betaalmethoden",
      payment_methods_desc: "Kies de meest geschikte methode voor jou",
      bank_transfer: "Bankoverschrijving",
      credit_card: "Creditcard",
      paypal: "PayPal",
      klarna_3: "Klarna 3 Termijnen",
      
      about_title: "Over Ons",
      about_desc: "Onze kiosk wordt met passie beheerd door Cerasuolo Massimiliano en Rita Colarusso, een historische familie van krantenverkopers in Napels met jarenlange ervaring in de sector.",
      about_more: "Meer over ons",
      
      f1_modeling: "F1 Modelbouw",
      f1_modeling_desc: "De grote Ferrari's, McLarens, Mercedes en alle historische teams. Schaalmodellen van de beste uitgevers.",
      pokemon_tcg: "Pokémon TCG",
      pokemon_tcg_desc: "Mystery Boxes, zeldzame kaarten, speciale collecties en alle officiële Trading Card Game producten.",
      online_selling: "Online Verkoop",
      online_selling_desc: "Vind onze producten op eBay en Wallapop voor gemakkelijk winkelen vanuit huis.",
      
      discover_products: "Ontdek Producten",
      exclusive_collections: "Exclusieve Collecties sinds 1985", hero_main_title: "Modelbouw, Pokemon en Verzamelobjecten",
      hero_main_desc: "Wereldwijde verzending — Veilige betalingen — Zeldzame stukken", buy_now: "NU KOPEN",
      discover_bestsellers: "Bestsellers Ontdekken", offers_this_week: "Aanbiedingen alleen deze week geldig",
      explore_collections: "Collecties Verkennen", bestsellers_title: "Meest Verkocht", bestsellers_desc: "Gekozen door onze klanten",
      view_all_catalog: "BEKIJK HELE CATALOGUS", limited_offer: "Beperkte Aanbieding", weekly_promo: "Weekaanbieding",
      weekly_promo_desc: "Verlaagde verzending + korting op het 3e product!", discover_offer: "ONTDEK DE AANBIEDING",
      insured_shipping: "Verzekerde Verzending", insured_shipping_desc: "Garantie tot €99",
      pay_installments: "Betaal in 3 Termijnen", pay_installments_desc: "Met Klarna — Rentevrij",
      secure_payments: "100% Veilige Betalingen", secure_payments_desc: "PayPal, Kaart, Overschrijving, Satispay",
      customer_reviews: "Wat Onze Klanten Zeggen", verified_reviews: "Geverifieerde beoordelingen",
      leave_review: "Schrijf een Beoordeling", close_form: "Sluiten", no_reviews: "Nog geen beoordelingen — Wees de eerste!",
      stay_updated: "Blijf Op de Hoogte", newsletter_desc: "Nieuwkomers en exclusieve aanbiedingen in uw email",
      subscribe_now: "NU ABONNEREN", sending: "Verzenden...", follow_social: "Volg ons",
      bestseller_badge: "BESTSELLER", preorder_badge: "VOORBESTELLING", available: "Beschikbaar", preorder_now: "Nu Voorbestellen",
      last_pieces: "Laatste", pieces: "stuks!", available_from: "Beschikbaar vanaf",
      your_email: "Uw email", your_name_opt: "Uw naam (optioneel)", submit_review: "Beoordeling Versturen",
      name: "Naam", email: "Email", product: "Product", select_product: "Selecteer product...", rating: "Beoordeling", comment: "Opmerking"
    },
    
    products: {
      title: "Onze Producten",
      subtitle: "Ontdek onze collecties",
      catalog_updating: "Catalogus in Update",
      catalog_updating_desc: "We uploaden onze volledige catalogus. Neem ondertussen contact met ons op voor informatie over beschikbare producten!",
      filter_category: "Filter op Categorie",
      all_categories: "Alle Categorieën",
      search_placeholder: "Zoek producten...",
      sort_by: "Sorteer op:",
      sort_newest: "Nieuwste",
      sort_price_low: "Prijs: Laag naar Hoog",
      sort_price_high: "Prijs: Hoog naar Laag",
      add_to_cart: "Toevoegen aan Winkelwagen",
      request_info: "Vraag Info",
      out_of_stock: "Uitverkocht",
      in_stock: "Beschikbaar",
      call_us: "Bel Ons"
    },
    
    product: {
      description: "Beschrijving",
      details: "Productdetails",
      category: "Categorie",
      price: "Prijs",
      quantity: "Aantal",
      add_to_cart: "Toevoegen aan Winkelwagen",
      out_of_stock: "Product Uitverkocht",
      back_to_products: "Terug naar Producten"
    },
    
    cart: {
      title: "Winkelwagen",
      empty: "Je winkelwagen is leeg",
      empty_desc: "Voeg producten toe om te beginnen met winkelen",
      continue_shopping: "Verder Winkelen",
      product: "Product",
      quantity: "Aantal",
      price: "Prijs",
      total: "Totaal",
      subtotal: "Subtotaal",
      shipping: "Verzending",
      order_total: "Besteltotaal",
      proceed_checkout: "Naar Kassa",
      remove: "Verwijder"
    },
    
    checkout: {
      title: "Afrekenen",
      customer_info: "Klantinformatie",
      name: "Volledige Naam",
      email: "Email",
      phone: "Telefoon",
      address: "Adres",
      city: "Stad",
      zip: "Postcode",
      country: "Land",
      notes: "Opmerkingen (optioneel)",
      payment_method: "Betaalmethode",
      cash_on_delivery: "Rembours",
      bank_transfer: "Bankoverschrijving",
      paypal: "PayPal",
      credit_card: "Creditcard/Stripe",
      place_order: "Plaats Bestelling",
      order_summary: "Bestelover​zicht"
    },
    
    about: {
      title: "Over Ons",
      subtitle: "Ons verhaal en passie",
      intro: "Onze kiosk wordt met passie beheerd door Cerasuolo Massimiliano en Rita Colarusso, een historische familie van krantenverkopers in Napels met jarenlange ervaring in de sector.",
      specialization: "We zijn gespecialiseerd in F1 modelbouw van de beste uitgevers en Pokémon collecties, en bieden onze klanten kwaliteitsproducten en persoonlijke service."
    },
    
    contact: {
      title: "Neem Contact Op",
      subtitle: "We zijn hier om te helpen",
      info: "Contactinformatie",
      address: "Adres",
      address_value: "Corso Europa 175, 80010 Villaricca (NA)",
      phone: "Telefoon",
      email: "Email",
      hours: "Openingstijden",
      monday_friday: "Maandag - Vrijdag",
      saturday: "Zaterdag",
      sunday: "Zondag",
      closed: "Gesloten",
      send_message: "Verstuur Bericht",
      your_name: "Jouw naam",
      your_email: "Jouw email",
      your_message: "Jouw bericht",
      send: "Verstuur"
    },
    
    footer: {
      copyright: "© 2024 Edicola Cerasuolo - Corso Europa 175, 80010 Villaricca (NA)",
      info: "Voor productinformatie"
    },
    
    common: {
      loading: "Laden...",
      error: "Fout",
      success: "Succes",
      close: "Sluiten",
      save: "Opslaan",
      cancel: "Annuleren",
      delete: "Verwijderen",
      edit: "Bewerken",
      view: "Bekijken",
      search: "Zoeken",
      filter: "Filteren",
      sort: "Sorteren"
    }
  },
  
  lb: {
    // Luxembourgish - Using German as base with some modifications
    nav: {
      home: "Startseite",
      products: "Produkter",
      about: "Iwwer Eis",
      contact: "Kontakt",
      terms: "Allgemeng Geschäftsbedéngungen",
      management: "Verwaltung",
      cart: "Warekuerf",
      login: "Aloggen",
      logout: "Ausloggen"
    },
    
    home: {
      hero_title: "Wëllkomm bei Edicola Cerasuolo",
      hero_subtitle: "F1-Modellbau, Pokémon TCG a Qualitéitssammelstécker",
      hero_description: "Entdeckt eis Auswiel un F1-Modeller, Pokémon TCG a Spezialcollectiounen",
      shop_now: "Produkter Entdecken",
      contact_us: "Kontaktéiert Eis",
      
      secure_shipping: "VERSÉCHERTE LIWWERUNG",
      secure_shipping_desc: "Garantéiert bis 99€ - Iwwer 99€ op Käschte vum Client",
      pay_3_installments: "AN 3 RATEN BEZUELEN",
      pay_3_installments_desc: "Zënsfräi, keng zousätzlech Käschten!",
      paypal_3_rates: "PayPal - An 3 Raten Bezuelen",
      
      presale_title: "Virverkafsproukter",
      presale_desc: "Virbestellt kommend Neiheeten mat exklusive Virdeeler",
      presale_price: "Reduzéierte Präis",
      presale_delivery: "Garantéiert Liwwerung",
      presale_btn: "Virverkaf Entdecken",
      
      reservation_title: "Reservéierungsproukter",
      reservation_desc: "Séchert Iech Är Liiblings-Sammelstécker",
      reservation_free: "Gratis Reservéierung",
      reservation_notify: "Disponibilitéitsnotifikatioun",
      reservation_btn: "Reservéierungen Ukucken",
      
      online_sale: "Online-Verkaf",
      online_sale_desc: "Duerchsicht eisen Katalog a wielt d'Produkter déi Iech interesséieren",
      go_to_products: "Bei d'Produkter",
      
      payment_methods: "Bezuelmethod",
      payment_methods_desc: "Wielt déi bequemst Method fir Iech",
      bank_transfer: "Bankiwwerweisung",
      credit_card: "Kreditkaart",
      paypal: "PayPal",
      klarna_3: "Klarna 3 Raten",
      
      about_title: "Iwwer Eis",
      about_desc: "Eise Kiosk gëtt mat Passioun vum Cerasuolo Massimiliano an der Rita Colarusso geféiert, eng historesch Famill vu Zäitungsverkeefer zu Neapel mat laangjäreger Erfarung am Secteur.",
      about_more: "Méi iwwer eis",
      
      f1_modeling: "F1-Modellbau",
      f1_modeling_desc: "Déi grouss Ferraris, McLarens, Mercedes an all historesch Equippen. Modeller am Moossstab vun de beschte Verléier.",
      pokemon_tcg: "Pokémon TCG",
      pokemon_tcg_desc: "Mystery Boxen, rar Kaarten, Spezialcollectiounen an all offiziell Trading Card Game Produkter.",
      online_selling: "Online-Verkaf",
      online_selling_desc: "Fannt eis Produkter op eBay a Wallapop fir bequem Akafen vun Doheem.",
      
      discover_products: "Produkter Entdecken",
      exclusive_collections: "Exklusiv Sammlungen zënter 1985", hero_main_title: "Modellbau, Pokemon an Sammlerstécker",
      hero_main_desc: "Weltwäit Versand — Sécher Bezuelungen — Seelen Stécker", buy_now: "ELO KAFEN",
      discover_bestsellers: "Bestseller Entdecken", offers_this_week: "Offere nëmme dës Woch gëlteg",
      explore_collections: "Sammlungen Entdecken", bestsellers_title: "Meescht Verkaf", bestsellers_desc: "Vu eise Clienten gewielt",
      view_all_catalog: "GANZEN KATALOG KUCKEN", limited_offer: "Limitéiert Offer", weekly_promo: "Wochepromo",
      weekly_promo_desc: "Reduzéierte Versand + Rabatt op den 3. Produkt!", discover_offer: "OFFER ENTDECKEN",
      insured_shipping: "Versécherte Versand", insured_shipping_desc: "Garantie bis €99",
      pay_installments: "A 3 Raten Bezuelen", pay_installments_desc: "Mat Klarna — Ouni Zinsen",
      secure_payments: "100% Sécher Bezuelungen", secure_payments_desc: "PayPal, Kaart, Iwwerweisung, Satispay",
      customer_reviews: "Wat Eis Clienten Soen", verified_reviews: "Verifizéiert Bewäertungen",
      leave_review: "Bewäertung Schreiwen", close_form: "Zoumaachen", no_reviews: "Nach keng Bewäertungen — Sidd den Éischten!",
      stay_updated: "Bleift Informéiert", newsletter_desc: "Neiegkeeten an exklusiv Offeren an Ärer Email",
      subscribe_now: "ELO ABONNÉIEREN", sending: "Schécken...", follow_social: "Follegt eis",
      bestseller_badge: "BESTSELLER", preorder_badge: "VIRBESTELLUNG", available: "Verfügbar", preorder_now: "Elo Virbestellen",
      last_pieces: "Lescht", pieces: "Stéck!", available_from: "Verfügbar ab",
      your_email: "Är Email", your_name_opt: "Ären Numm (optional)", submit_review: "Bewäertung Schécken",
      name: "Numm", email: "Email", product: "Produkt", select_product: "Produkt auswielen...", rating: "Bewäertung", comment: "Kommentar"
    },
    
    products: {
      title: "Eis Produkter",
      subtitle: "Entdeckt eis Collectiounen",
      catalog_updating: "Katalog gëtt aktualiséiert",
      catalog_updating_desc: "Mir aktualiséieren eise komplette Katalog. An der Zwëschenzäit kontaktéiert eis fir Informatiounen iwwer disponibel Produkter!",
      filter_category: "No Kategorie Filteren",
      all_categories: "All Kategorien",
      search_placeholder: "Produkter sichen...",
      sort_by: "Sortéieren no:",
      sort_newest: "Neiste",
      sort_price_low: "Präis: Niddreg bis Héich",
      sort_price_high: "Präis: Héich bis Niddreg",
      add_to_cart: "An de Warekuerf",
      request_info: "Info Ufroe",
      out_of_stock: "Ausverkaaft",
      in_stock: "Disponibel",
      call_us: "Rufft Eis Un"
    },
    
    product: {
      description: "Beschreiwung",
      details: "Produktdetailer",
      category: "Kategorie",
      price: "Präis",
      quantity: "Quantitéit",
      add_to_cart: "An de Warekuerf",
      out_of_stock: "Produkt Ausverkaaft",
      back_to_products: "Zréck bei d'Produkter"
    },
    
    cart: {
      title: "Warekuerf",
      empty: "Äre Warekuerf ass eidel",
      empty_desc: "Setzt Produkter derbäi fir mam Akafen unzefänken",
      continue_shopping: "Weider Akafen",
      product: "Produkt",
      quantity: "Quantitéit",
      price: "Präis",
      total: "Total",
      subtotal: "Ënner-Total",
      shipping: "Versand",
      order_total: "Bestellung Total",
      proceed_checkout: "Bei d'Kees",
      remove: "Ewechhuelen"
    },
    
    checkout: {
      title: "Ofrechnen",
      customer_info: "Clientsinformatioun",
      name: "Vollstännegen Numm",
      email: "E-Mail",
      phone: "Telefon",
      address: "Adress",
      city: "Stad",
      zip: "Postcode",
      country: "Land",
      notes: "Notizen (optional)",
      payment_method: "Bezuelmethod",
      cash_on_delivery: "Bezuelen bei Liwwerung",
      bank_transfer: "Bankiwwerweisung",
      paypal: "PayPal",
      credit_card: "Kreditkaart/Stripe",
      place_order: "Bestellung Opginn",
      order_summary: "Bestellungsiwwersiicht"
    },
    
    about: {
      title: "Iwwer Eis",
      subtitle: "Eis Geschicht a Passioun",
      intro: "Eise Kiosk gëtt mat Passioun vum Cerasuolo Massimiliano an der Rita Colarusso geféiert, eng historesch Famill vu Zäitungsverkeefer zu Neapel mat laangjäreger Erfarung am Secteur.",
      specialization: "Mir sinn spezialiséiert op F1-Modellbau vun de beschte Verléier a Pokémon-Collectiounen, a bidden eise Clienten Qualitéitsproukter a perséinleche Service."
    },
    
    contact: {
      title: "Kontaktéiert Eis",
      subtitle: "Mir sinn hei fir ze hëllefen",
      info: "Kontaktinformatioun",
      address: "Adress",
      address_value: "Corso Europa 175, 80010 Villaricca (NA)",
      phone: "Telefon",
      email: "E-Mail",
      hours: "Ouvertureszäiten",
      monday_friday: "Méindeg - Freides",
      saturday: "Samschdeg",
      sunday: "Sonndes",
      closed: "Zou",
      send_message: "Message Schécken",
      your_name: "Ären Numm",
      your_email: "Är E-Mail",
      your_message: "Är Message",
      send: "Schécken"
    },
    
    footer: {
      copyright: "© 2024 Edicola Cerasuolo - Corso Europa 175, 80010 Villaricca (NA)",
      info: "Fir Produktinformatioun"
    },
    
    common: {
      loading: "Lueden...",
      error: "Feeler",
      success: "Erfolleg",
      close: "Zoumaachen",
      save: "Späicheren",
      cancel: "Ofbriechen",
      delete: "Läschen",
      edit: "Änneren",
      view: "Ukucken",
      search: "Sichen",
      filter: "Filteren",
      sort: "Sortéieren"
    }
  },
  hi: {
    nav: {
      home: "होम",
      products: "उत्पाद",
      about: "हमारे बारे में",
      contact: "संपर्क",
      terms: "नियम और शर्तें",
      management: "प्रबंधन",
      cart: "कार्ट",
      login: "लॉगिन",
      logout: "लॉगआउट"
    },
    home: {
      hero_title: "एडिकोला चेरासुओलो में आपका स्वागत है",
      hero_subtitle: "F1 मॉडलिंग, पोकेमॉन TCG और गुणवत्ता संग्रहणीय",
      hero_description: "F1 मॉडल, पोकेमॉन TCG और विशेष संग्रह का चयन खोजें",
      shop_now: "अभी खरीदें",
      contact_us: "संपर्क करें",
      secure_shipping: "बीमित शिपिंग",
      secure_shipping_desc: "€99 तक गारंटीकृत - €99 से अधिक ग्राहक के खर्च पर",
      pay_3_installments: "3 किस्तों में भुगतान करें",
      pay_3_installments_desc: "बिना ब्याज, बिना अतिरिक्त शुल्क!",
      paypal_3_rates: "PayPal - 3 किस्तों में भुगतान",
      presale_title: "प्री-सेल उत्पाद",
      presale_desc: "विशेष लाभ के साथ आगामी आगमन को प्री-ऑर्डर करें",
      presale_price: "रियायती मूल्य",
      presale_delivery: "गारंटीकृत डिलीवरी",
      presale_btn: "प्री-सेल देखें",
      reservation_title: "आरक्षण उत्पाद",
      reservation_desc: "अपने पसंदीदा संग्रहणीय सुरक्षित करें",
      reservation_free: "मुफ्त आरक्षण",
      reservation_notify: "उपलब्धता सूचना",
      reservation_btn: "आरक्षण देखें",
      online_sale: "ऑनलाइन स्टोर",
      online_sale_desc: "हमारा कैटलॉग ब्राउज़ करें और अपनी पसंद के उत्पाद चुनें",
      go_to_products: "उत्पादों पर जाएं",
      payment_methods: "भुगतान के तरीके",
      payment_methods_desc: "अपने लिए सबसे सुविधाजनक तरीका चुनें",
      bank_transfer: "बैंक ट्रांसफर",
      credit_card: "क्रेडिट कार्ड",
      paypal: "PayPal",
      klarna_3: "Klarna 3 किस्तें",
      about_title: "हमारे बारे में",
      about_desc: "हमारी दुकान चेरासुओलो मासिमिलियानो और रीता कोलारुस्सो द्वारा जुनून के साथ चलाई जाती है, नेपल्स में समाचार पत्र विक्रेताओं का एक ऐतिहासिक परिवार।",
      about_more: "हमारे बारे में और जानें",
      f1_modeling: "F1 मॉडलिंग",
      f1_modeling_desc: "महान फेरारी, मैकलारेन, मर्सिडीज और सभी ऐतिहासिक टीमें। सर्वश्रेष्ठ प्रकाशकों के स्केल मॉडल।",
      pokemon_tcg: "पोकेमॉन TCG",
      pokemon_tcg_desc: "मिस्ट्री बॉक्स, दुर्लभ कार्ड, विशेष संग्रह और सभी आधिकारिक ट्रेडिंग कार्ड गेम उत्पाद।",
      online_selling: "ऑनलाइन बिक्री",
      online_selling_desc: "सुविधाजनक होम शॉपिंग के लिए eBay और Wallapop पर हमारे उत्पाद खोजें।",
      discover_products: "उत्पाद खोजें",
      exclusive_collections: "1985 से विशेष संग्रह", hero_main_title: "मॉडलिंग, पोकेमॉन और संग्रहणीय",
      hero_main_desc: "दुनिया भर में शिपिंग — सुरक्षित भुगतान — दुर्लभ टुकड़े", buy_now: "अभी खरीदें",
      discover_bestsellers: "बेस्टसेलर खोजें", offers_this_week: "ऑफर केवल इस सप्ताह मान्य",
      explore_collections: "संग्रह देखें", bestsellers_title: "सबसे ज्यादा बिकने वाले", bestsellers_desc: "हमारे ग्राहकों द्वारा चुने गए",
      view_all_catalog: "पूरा कैटलॉग देखें", limited_offer: "सीमित ऑफर", weekly_promo: "साप्ताहिक प्रोमो",
      weekly_promo_desc: "कम शिपिंग + तीसरे उत्पाद पर छूट — केवल इस सप्ताह!",
      discover_offer: "ऑफर देखें", insured_shipping: "बीमित शिपिंग", insured_shipping_desc: "€99 तक गारंटी",
      pay_installments: "3 किस्तों में भुगतान", pay_installments_desc: "Klarna के साथ — बिना ब्याज",
      secure_payments: "100% सुरक्षित भुगतान", secure_payments_desc: "PayPal, कार्ड, बैंक ट्रांसफर, Satispay",
      customer_reviews: "हमारे ग्राहक क्या कहते हैं", verified_reviews: "सत्यापित समीक्षाएं",
      leave_review: "समीक्षा लिखें", close_form: "बंद करें", no_reviews: "अभी कोई समीक्षा नहीं — पहले बनें!",
      stay_updated: "अपडेट रहें", newsletter_desc: "नए उत्पाद और विशेष ऑफर सीधे आपके ईमेल पर",
      subscribe_now: "अभी सदस्यता लें", sending: "भेज रहे हैं...", follow_social: "हमें फॉलो करें",
      bestseller_badge: "बेस्टसेलर", preorder_badge: "प्री-ऑर्डर", available: "उपलब्ध", preorder_now: "अभी प्री-ऑर्डर करें",
      last_pieces: "अंतिम", pieces: "टुकड़े!", available_from: "उपलब्ध तिथि",
      your_email: "आपका ईमेल", your_name_opt: "आपका नाम (वैकल्पिक)", submit_review: "समीक्षा भेजें",
      name: "नाम", email: "ईमेल", product: "उत्पाद", select_product: "उत्पाद चुनें...", rating: "रेटिंग", comment: "टिप्पणी"
    },
    products: {
      title: "हमारे उत्पाद",
      subtitle: "हमारे संग्रह खोजें",
      catalog_updating: "कैटलॉग अपडेट हो रहा है",
      catalog_updating_desc: "हम अपना पूरा कैटलॉग अपलोड कर रहे हैं। इस बीच, उपलब्ध उत्पादों की जानकारी के लिए हमसे संपर्क करें!",
      filter_category: "श्रेणी के अनुसार फ़िल्टर करें",
      all_categories: "सभी श्रेणियां",
      search_placeholder: "उत्पाद खोजें...",
      sort_by: "क्रमबद्ध करें:",
      sort_newest: "नवीनतम",
      sort_price_low: "मूल्य: कम से अधिक",
      sort_price_high: "मूल्य: अधिक से कम",
      add_to_cart: "कार्ट में डालें",
      request_info: "जानकारी का अनुरोध करें",
      out_of_stock: "स्टॉक में नहीं",
      in_stock: "स्टॉक में",
      call_us: "हमें कॉल करें"
    },
    product: {
      description: "विवरण",
      details: "उत्पाद विवरण",
      category: "श्रेणी",
      price: "मूल्य",
      quantity: "मात्रा",
      add_to_cart: "कार्ट में डालें",
      out_of_stock: "उत्पाद स्टॉक में नहीं",
      back_to_products: "उत्पादों पर वापस"
    },
    cart: {
      title: "शॉपिंग कार्ट",
      empty: "आपका कार्ट खाली है",
      empty_desc: "खरीदारी शुरू करने के लिए उत्पाद जोड़ें",
      continue_shopping: "खरीदारी जारी रखें",
      product: "उत्पाद",
      quantity: "मात्रा",
      price: "मूल्य",
      total: "कुल",
      subtotal: "उप-योग",
      shipping: "शिपिंग",
      order_total: "ऑर्डर कुल",
      proceed_checkout: "चेकआउट पर जाएं",
      remove: "हटाएं"
    },
    checkout: {
      title: "चेकआउट",
      customer_info: "ग्राहक जानकारी",
      name: "पूरा नाम",
      email: "ईमेल",
      phone: "फ़ोन",
      address: "पता",
      city: "शहर",
      zip: "पिन कोड",
      country: "देश",
      notes: "नोट्स (वैकल्पिक)",
      payment_method: "भुगतान का तरीका",
      cash_on_delivery: "कैश ऑन डिलीवरी",
      bank_transfer: "बैंक ट्रांसफर",
      paypal: "PayPal",
      credit_card: "क्रेडिट कार्ड/Stripe",
      place_order: "ऑर्डर दें",
      order_summary: "ऑर्डर सारांश"
    },
    about: {
      title: "हमारे बारे में",
      subtitle: "हमारी कहानी और जुनून",
      intro: "हमारी दुकान चेरासुओलो मासिमिलियानो और रीता कोलारुस्सो द्वारा जुनून के साथ चलाई जाती है, नेपल्स में समाचार पत्र विक्रेताओं का एक ऐतिहासिक परिवार।",
      specialization: "हम सर्वश्रेष्ठ प्रकाशकों से F1 मॉडलिंग और पोकेमॉन संग्रह में विशेषज्ञ हैं।"
    },
    contact: {
      title: "संपर्क करें",
      subtitle: "हम मदद के लिए यहां हैं",
      info: "संपर्क जानकारी",
      address: "पता",
      address_value: "Corso Europa 175, 80010 Villaricca (NA)",
      phone: "फ़ोन",
      email: "ईमेल",
      hours: "खुलने का समय",
      monday_friday: "सोमवार - शुक्रवार",
      saturday: "शनिवार",
      sunday: "रविवार",
      closed: "बंद",
      send_message: "संदेश भेजें",
      your_name: "आपका नाम",
      your_email: "आपका ईमेल",
      your_message: "आपका संदेश",
      send: "भेजें"
    },
    footer: {
      copyright: "© 2024 Edicola Cerasuolo - Corso Europa 175, 80010 Villaricca (NA)",
      info: "उत्पाद जानकारी के लिए"
    },
    common: {
      loading: "लोड हो रहा है...",
      error: "त्रुटि",
      success: "सफलता",
      close: "बंद करें",
      save: "सहेजें",
      cancel: "रद्द करें",
      delete: "हटाएं",
      edit: "संपादित करें",
      view: "देखें",
      search: "खोजें",
      filter: "फ़िल्टर",
      sort: "क्रमबद्ध"
    }
  },
  zh: {
    nav: {
      home: "首页",
      products: "产品",
      about: "关于我们",
      contact: "联系我们",
      terms: "销售条款",
      management: "管理",
      cart: "购物车",
      login: "登录",
      logout: "退出"
    },
    home: {
      hero_title: "欢迎来到Edicola Cerasuolo",
      hero_subtitle: "F1模型、宝可梦TCG和优质收藏品",
      hero_description: "探索我们精选的F1模型、宝可梦TCG和特别收藏",
      shop_now: "立即购买",
      contact_us: "联系我们",
      secure_shipping: "保险配送",
      secure_shipping_desc: "最高€99保障 — 超过€99由客户承担",
      pay_3_installments: "分3期付款",
      pay_3_installments_desc: "无利息，无额外费用！",
      paypal_3_rates: "PayPal - 分3期付款",
      presale_title: "预售产品",
      presale_desc: "享受特别优惠的提前预订",
      presale_price: "优惠价格",
      presale_delivery: "保证送达",
      presale_btn: "查看预售",
      reservation_title: "预订产品",
      reservation_desc: "锁定您喜爱的收藏品",
      reservation_free: "免费预订",
      reservation_notify: "到货通知",
      reservation_btn: "查看预订",
      online_sale: "在线商店",
      online_sale_desc: "浏览我们的目录，选择您喜欢的产品",
      go_to_products: "前往产品",
      payment_methods: "支付方式",
      payment_methods_desc: "选择最方便的支付方式",
      bank_transfer: "银行转账",
      credit_card: "信用卡",
      paypal: "PayPal",
      klarna_3: "Klarna 3期",
      about_title: "关于我们",
      about_desc: "我们的商店由Cerasuolo Massimiliano和Rita Colarusso热情经营，是那不勒斯历史悠久的报刊亭家族。",
      about_more: "了解更多",
      f1_modeling: "F1模型",
      f1_modeling_desc: "伟大的法拉利、迈凯伦、梅赛德斯和所有历史车队。最佳出版商的比例模型。",
      pokemon_tcg: "宝可梦TCG",
      pokemon_tcg_desc: "神秘盒子、稀有卡片、特别收藏和所有官方集换式卡牌游戏产品。",
      online_selling: "在线销售",
      online_selling_desc: "在eBay和Wallapop上找到我们的产品，享受便捷的网购体验。",
      discover_products: "探索产品",
      exclusive_collections: "1985年以来的专属收藏",
      hero_main_title: "模型、宝可梦和收藏品",
      hero_main_desc: "全球配送 — 安全支付 — 稀有珍品",
      buy_now: "立即购买",
      discover_bestsellers: "发现畅销品",
      offers_this_week: "优惠仅限本周",
      explore_collections: "探索收藏系列",
      bestsellers_title: "热销产品",
      bestsellers_desc: "客户之选 — 限量供应",
      view_all_catalog: "查看完整目录",
      limited_offer: "限时优惠",
      weekly_promo: "每周促销",
      weekly_promo_desc: "运费优惠 + 第三件商品折扣 — 仅限本周！",
      discover_offer: "查看优惠",
      insured_shipping: "保险配送",
      insured_shipping_desc: "最高€99保障 — 始终包含追踪",
      pay_installments: "分3期付款",
      pay_installments_desc: "Klarna — 免息",
      secure_payments: "100%安全支付",
      secure_payments_desc: "PayPal、信用卡、银行转账、货到付款、Satispay",
      customer_reviews: "客户评价",
      verified_reviews: "来自买家的真实评价",
      leave_review: "留下评价",
      close_form: "关闭",
      no_reviews: "暂无评价 — 成为第一个！",
      stay_updated: "保持更新",
      newsletter_desc: "新品、专属优惠直接发送到您的邮箱",
      subscribe_now: "立即订阅",
      sending: "发送中...",
      follow_social: "关注我们",
      bestseller_badge: "畅销",
      preorder_badge: "预购",
      available: "有货",
      preorder_now: "立即预购",
      last_pieces: "最后",
      pieces: "件！",
      available_from: "上市日期",
      your_email: "您的邮箱",
      your_name_opt: "您的姓名（选填）",
      submit_review: "提交评价",
      name: "姓名",
      email: "邮箱",
      product: "产品",
      select_product: "选择产品...",
      rating: "评分",
      comment: "评论"
    },
    products: {
      title: "我们的产品",
      subtitle: "探索我们的收藏",
      catalog_updating: "目录更新中",
      catalog_updating_desc: "我们正在上传完整目录。请联系我们了解可用产品！",
      filter_category: "按类别筛选",
      all_categories: "所有类别",
      search_placeholder: "搜索产品...",
      sort_by: "排序：",
      sort_newest: "最新",
      sort_price_low: "价格：从低到高",
      sort_price_high: "价格：从高到低",
      add_to_cart: "加入购物车",
      request_info: "咨询信息",
      out_of_stock: "缺货",
      in_stock: "有货",
      call_us: "联系我们"
    },
    product: {
      description: "描述",
      details: "产品详情",
      category: "类别",
      price: "价格",
      quantity: "数量",
      add_to_cart: "加入购物车",
      out_of_stock: "产品缺货",
      back_to_products: "返回产品"
    },
    cart: {
      title: "购物车",
      empty: "您的购物车是空的",
      empty_desc: "添加产品开始购物",
      continue_shopping: "继续购物",
      product: "产品",
      quantity: "数量",
      price: "价格",
      total: "总计",
      subtotal: "小计",
      shipping: "运费",
      order_total: "订单总计",
      proceed_checkout: "去结算",
      remove: "删除"
    },
    checkout: {
      title: "结算",
      customer_info: "客户信息",
      name: "全名",
      email: "邮箱",
      phone: "电话",
      address: "地址",
      city: "城市",
      zip: "邮编",
      country: "国家",
      notes: "备注（选填）",
      payment_method: "支付方式",
      cash_on_delivery: "货到付款",
      bank_transfer: "银行转账",
      paypal: "PayPal",
      credit_card: "信用卡/Stripe",
      place_order: "下单",
      order_summary: "订单摘要"
    },
    about: {
      title: "关于我们",
      subtitle: "我们的故事和热情",
      intro: "我们的商店由Cerasuolo Massimiliano和Rita Colarusso热情经营，是那不勒斯历史悠久的报刊亭家族。",
      specialization: "我们专注于最佳出版商的F1模型和宝可梦收藏品。"
    },
    contact: {
      title: "联系我们",
      subtitle: "我们随时为您服务",
      info: "联系信息",
      address: "地址",
      address_value: "Corso Europa 175, 80010 Villaricca (NA)",
      phone: "电话",
      email: "邮箱",
      hours: "营业时间",
      monday_friday: "周一至周五",
      saturday: "周六",
      sunday: "周日",
      closed: "休息",
      send_message: "发送消息",
      your_name: "您的姓名",
      your_email: "您的邮箱",
      your_message: "您的留言",
      send: "发送"
    },
    footer: {
      copyright: "© 2024 Edicola Cerasuolo - Corso Europa 175, 80010 Villaricca (NA)",
      info: "产品信息咨询"
    },
    common: {
      loading: "加载中...",
      error: "错误",
      success: "成功",
      close: "关闭",
      save: "保存",
      cancel: "取消",
      delete: "删除",
      edit: "编辑",
      view: "查看",
      search: "搜索",
      filter: "筛选",
      sort: "排序"
    }
  }
};

// Available languages configuration
export const languages = [
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
  { code: 'pl', name: 'Polski', flag: '🇵🇱' },
  { code: 'ro', name: 'Română', flag: '🇷🇴' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
  { code: 'lb', name: 'Lëtzebuergesch', flag: '🇱🇺' },
  { code: 'hi', name: 'हिन्दी', flag: '🇮🇳' },
  { code: 'zh', name: '中文', flag: '🇨🇳' }
];
